import {
    captureError,
    checkAreObjArraysEqual,
    commaSeparate, getArrayMaxByProperty, getArrayMinByProperty, getChunks,
    getCurrentGame, getRandomChoice,
    getRandomInt,
    getRandomSample, getRosterMemberAlignment, getRosterMemberPopularity,
    getUniqueObjects, limitValueBetweenRange,
    objectInArray, weightedChoice
} from "./helpers.js"
import {
    addTagTeamSuperstars,
    getTagTeamSuperstars,
    removeTagTeamSuperstars,
    TagTeam
} from "../models/tagTeam.js";
import {
    getMatchChampionships,
    getMatchParticipants,
    getAllSuperstarsForMatch,
    getMatchEvent,
    getMatchGimmickMatch,
    getMatchFeuds,
    getMatchTournament,
    Match,
    addMatchChampionships,
    addMatchFeuds,
    addMatchParticipants, removeMatchChampionships, removeMatchFeud, getMatchTagTeams
} from "../models/match.js";
import {
    addSuperstarChampionships,
    getSuperstarChampionships,
    getSuperstarFactions,
    getSuperstarTagTeams
} from "../models/superstar.js";
import {
    getChampionshipMatchData,
    compareChampionships,
    checkAreChampionshipsEqual,
    checkChampionshipGimmickRestriction, getChampionshipHolder, getTagChampionshipsSets
} from "./championships.js";
import {
    getSuperstarMatchOrSegmentData,
    getRosterMemberSuperstars,
    checkSuperstarBrandAvailability,
    getSuperstarChampionshipsFromCompanyChampionships,
    checkAvailability,
    getSuperstarLastName,
    getSuperstarActiveFactions,
    checkSuperstarGraphicMask,
    checkSuperstarSegmentAvailability,
    getSuperstarDisplayData,
    getEmptySuperstarGraphic,
    getGraphicForSuperstar,
    getSuperstarManagerUsedForMatchOrSegment,
    getSuperstarManagerGraphic,
} from "./superstars.js";
import {getTagTeamDisplayData, getTagTeamMatchData, removeTagTeam} from "./tagTeams.js";
import {getMatchAvailableChampionships, getVacatedChampionshipsForMatch} from "./championships.js";
import {
    getEventMatchesAndSegments,
    getEventMaximumMatchesAndSegments,
    getEventTitle
} from "./events.js";
import {getFeudData, getParticipantFeuds} from "./feuds.js";
import {getGameCurrentUserCompany, getGameMainUserCompany} from "./games.js";
import {
    generateGimmickMatchLocationName, generateGimmickMatchObjectName,
    getAvailableStaffMembersByRole,
    getCompanyLatestEvent,
    getCompanyParentEvents,
    getCompanyRosterByType
} from "./companies.js";
import {
    addEventMatchContracts,
    addEventMatches,
    getEventMatches,
    getEventSegments
} from "../models/event.js";
import {
    addCompanyChampionships,
    getCompanyChampionships, getCompanyFacilities, getCompanyGimmickMatches,
    getCompanyObjectives,
    getCompanyPowerups, getCompanyRosters,
    getCompanyStaff
} from "../models/company.js";
import {
    db, Superstars, TagTeams, Championships, Matches, Events, Factions, GimmickMatches,
    MatchContracts, Tournaments, Feuds, MatchesHash, FeudParticipantsHash, FeudMatchesHash, loadDb
} from "../models/models.js";
import {getTournamentMatches} from "../models/tournament.js";
import {
    addChampionshipMatchContracts,
    Championship,
    getChampionshipChampionshipReigns,
    getChampionshipMatchContract
} from "../models/championship.js";
import {deleteSegment, getHypeForFeuds, getHypeForParticipants} from "./segments.js";
import { addRosterTagTeams, getRosterSuperstars, getRosterTagTeams} from "../models/roster.js";
import {globalUser} from "./globals.js";
import {
    addSuperstarManagerToMatchOrSegment,
    removeSuperstarManagerFromMatchOrSegment,
    setManagersForMatchOrSegment
} from "./managers.js";
import {getFactionSuperstars} from "../models/faction.js";
import {getChampionshipDisplayName} from "../ui/ui-helpers.js";
import {addGimmickMatchMatches, getGimmickMatchCompany} from "../models/gimmickMatch.js";
import {traitsData} from "../data/traits.js";
import {MatchContract} from "../models/matchContract.js";
import {callupTalentToMainRoster, getRosterActiveTagTeams} from "./rosters.js";
import {matchFinishesData} from "../data/matchFinishes.js";
import {getRosterActiveFactions} from "./factions.js";
import {processPlayMatch} from "./processMatch.js";
import {loadUser} from "./user.js";
import {checkToGoToNextTutorialState} from "./tutorial.js";

async function getMatchData({match, cashinSingles = false, cashinTag = false, cashinTrios = false, history = false,
                            getChampionshipsAvailable = true, play = false, companyChampionships = null,
                            rosterSuperstars = null, game = null} = {}) {  // get_match_singles/get_match_tag
    let matchData = {};
    let matchParticipants = (await getMatchParticipants(match)).reverse();
    matchParticipants.reverse();
    let matchSuperstars = await getAllSuperstarsForMatch(match);
    let matchChampionships = await getMatchChampionships(match);
    let matchGimmick = await getMatchGimmickMatch(match);
    let matchEvent = await getMatchEvent(match);
    let canCashin = false;
    const refereeSuperstar = await getMatchRefereeSuperstar(match, rosterSuperstars);

    // Check if trios match, handicap match, get team size
    let trio = false;
    let teamSize;
    let handicapMatch = false;
    if (match.type === 'tag') {
        if (matchParticipants.length > 0) {
            const firstTeamSuperstars = await getTagTeamSuperstars(matchParticipants[0]);
            teamSize = firstTeamSuperstars.length;
            trio = matchParticipants[0].trio;
            // Check for handicap match by checking if any teams have unequal superstars
            for (const matchParticipant of matchParticipants) {
                if ((await getTagTeamSuperstars(matchParticipant)).length !== firstTeamSuperstars.length) {
                    handicapMatch = true;
                    break;
                }
            }
        }
        // Empty match e.g in tournament future round
        else {
            teamSize = trio ? 3 : 2;
        }
    }

    // Get handicap size
    if (handicapMatch) {
        matchData['handicapSize'] = await getMatchHandicapSize(matchParticipants);
    }

    // Get match championships data
    matchData['championships'] = [];
    matchChampionships.sort(compareChampionships);
    matchChampionships.forEach(x => {
        let championshipData = getChampionshipMatchData(x);
        matchData['championships'].push(championshipData);

        // Check if championship can be cashed in on
        if (!x.championshipContract && (cashinSingles || (cashinTag && !trio) || (cashinTrios && trio))) {
            canCashin = true
        }
    });

    let participantsData = [];
    // Get deeper data when playing match
    if (play) {
        for (const matchParticipant of matchParticipants) {
            let participantData;
            if (match.type === 'singles') {
                participantData = await getSuperstarDisplayData({
                    superstar: matchParticipant, rosterSuperstars: rosterSuperstars, managersUsed: match.managersUsed,
                    game: game
                });
            } else {
                participantData = await getTagTeamDisplayData({
                    tagTeam: matchParticipant, rosterSuperstars: rosterSuperstars, managersUsed: match.managersUsed,
                    game: game
                });
            }
            participantsData.push(participantData);
        }
    }
    // Get compact data when displaying match
    else {
        const dataFunction = match.type === 'singles' ? getSuperstarMatchOrSegmentData : getTagTeamMatchData;
        for (const matchParticipant of matchParticipants) {
            const participantData = await dataFunction(matchParticipant, matchChampionships, match.managersUsed,
                rosterSuperstars);
            participantsData.push(participantData);
        }
    }

    // Check if championships available for match
    if (getChampionshipsAvailable && !handicapMatch && matchParticipants.length > 0) { // Don't get for handicap matches
        // Find available championships from match participants and vacated championships
        let availableChampionshipsData = await getMatchAvailableChampionships(matchParticipants, matchSuperstars,
            companyChampionships, matchGimmick, matchEvent);
        let availableChampionships = availableChampionshipsData['availableChampionships'];
        availableChampionships.push(...getVacatedChampionshipsForMatch(match, companyChampionships, trio));
        if (availableChampionships.length > 0) {
            matchData['championshipsAvailable'] = true
        }
    }

    // If playing match and trioTagTeam are tag champions, transfer tag titles to participating members
    if (play && match.type === 'tag') {
        for (let matchParticipant of matchParticipants) {
            if (matchParticipant.trioTagTeam) {
                let trioTagTeamSuperstars = await getTagTeamSuperstars(matchParticipant);

                // Get trio superstars
                const teamTrio = (await getSuperstarTagTeams(trioTagTeamSuperstars[0])).find(x => x.trio);
                const trioSuperstars = teamTrio ? await getTagTeamSuperstars(teamTrio) : [];
                const trioSuperstarsIds = trioSuperstars.map(x => x.$loki);

                // Get all tag team title sets
                let tagChampionshipSets = getTagChampionshipsSets(companyChampionships.filter(x => x.tagTeam));

                // Check if each team title is held by a superstar of this team and one is present in match
                let foundTagChampionshipSets = [];
                for (let c of tagChampionshipSets) {
                    if (c.every(x => trioSuperstarsIds.includes(x.superstarId)) &&
                        c.some(x => objectInArray(x, matchChampionships))) {
                        foundTagChampionshipSets.push(c);
                    }
                }

                // Transfer each pair of tag titles to participating members
                for (const championshipsSet of foundTagChampionshipSets) {
                    for (const [i, c] of Object.entries(championshipsSet)) {
                        await addSuperstarChampionships(trioTagTeamSuperstars[i], [c]);
                    }
                }
            }
        }
    }

    // Get gimmick match graphic
    let gimmickMatchForGraphic = await getGimmickMatchForGraphic(matchGimmick, match);
    let gimmickMatchGraphic = getGimmickMatchGraphic(gimmickMatchForGraphic);

    // Get championships to remove from graphics
    let hangChampionships = checkHangChampionships(gimmickMatchGraphic);
    let championshipsToRemove = hangChampionships ? [...matchChampionships] : [];

    // Get graphics
    if (play) {
        let participantChampionships = [];
        for (const matchSuperstar of matchSuperstars) {
            participantChampionships = [...participantChampionships, ...await getSuperstarChampionships(matchSuperstar)];
        }
        matchData['graphics'] = await getMatchParticipantsGraphics(match, matchParticipants, participantChampionships,
            matchSuperstars, rosterSuperstars, refereeSuperstar, gimmickMatchForGraphic, championshipsToRemove);
        matchData['gimmickMatchGraphic'] = gimmickMatchGraphic;
        if (hangChampionships) {
            // Get top match championships to hang (get sets)
            let availableHangingChampionships = [];
            for (const c of matchChampionships) {
                if (c.graphic) {
                    availableHangingChampionships.push(...companyChampionships.filter(x => checkAreChampionshipsEqual(x, c)))
                }
            }
            availableHangingChampionships.sort((a, b) => b.xp - a.xp);
            matchData['hangingChampionships'] = availableHangingChampionships.slice(0, 2).map(x => x.graphic);
        }

        // Get other attributes displayed when playing match
        matchData['hype'] = getMatchHype(match);
        matchData['streakBonus'] = match.streakBonus;
        matchData['eventBonus'] = match.eventBonus;
        matchData['contractBonus'] = match.contractBonus;
        matchData['tournamentFinalBonus'] = match.tournamentFinalBonus;
        matchData['canCashin'] = canCashin;
    }

    // Add to data object
    matchData['participants'] = participantsData;
    matchData['uid'] = match.$loki;
    matchData['type'] = match.type;
    matchData['activeEffect'] = match.activeEffect;
    matchData['order'] = match.order;
    matchData['rating'] = match.rating;
    matchData['hidden'] = match.hidden;
    matchData['generated'] = {"objectToClaim": match.objectToClaim, "location": match.location};
    matchData['segmentType'] = "match";
    matchData['gimmick'] = (matchGimmick) ? matchGimmick.name : '';
    matchData['rules'] = matchGimmick ? matchGimmick.rules : false;
    matchData['consequence'] = matchGimmick ? matchGimmick.consequence : false;
    if (match.type === 'tag') {
        matchData['teamType'] = trio ? "trio" : "tag-team";
        matchData['largerTag'] = teamSize > 2 ? teamSize : false;
    }
    matchData['winnerName'] = match.winner ? match.winner : null;

    // Add feuds data
    const matchFeuds = await getMatchFeuds(match);
    matchData['feuds'] = await Promise.all(matchFeuds.map(x => getFeudData(x, true)));

    // Get referee name
    if (refereeSuperstar) {
        matchData['refereeName'] = refereeSuperstar.name
    }

    // Get tournament
    const matchTournament = await getMatchTournament(match);
    if (matchTournament) {
        matchData['tournamentName'] = matchTournament.name;
        matchData['tournamentRound'] = match.tournamentRound;
        matchData['tournamentGroup'] = getTournamentGroupName(match.tournamentGroup);
        matchData['tournamentRoundName'] = getTournamentRoundName(matchTournament.rounds, match.tournamentRound,
            match.tournamentGroup);
        if (match.tournamentRound === matchTournament.rounds && !matchTournament.annualTournament) {
            matchData['tournamentFinalBonus'] = getTournamentFinalBonus(matchTournament)
        }
    }

    if (history) {
        // Get winner data
        let winnerDict = {};
        winnerDict.name = match.winner;
        winnerDict.championshipsWon = match.championshipsWon;
        winnerDict.championshipsDefended = match.championshipsDefended;
        winnerDict.championshipsRetained = match.championshipsRetained;
        matchData['winner'] = winnerDict;

        // Get losers data
        let losers;
        if (match.loser) {
            losers = [match.loser]
        }
        else {
            losers = participantsData.filter(x => x.name !== match.winner)
        }
        matchData['losers'] = losers;

        // Get other data
        matchData['text'] = match.generatedText;
        matchData['event'] = await getMatchEventTitle(match);
        matchData['finishName'] = match.finishName;
        matchData['finishText'] = match.finishText;
    }

    return matchData;
}

function getTournamentFinalBonus(tournament) {  // Previously get_tournament_final_bonus
    const bonuses = {'A': 50, 'B': 25, 'C': 12};
    return bonuses[tournament.prestige] || 12;

}

function getTournamentGroupName(group) {  // Previously get_tournament_group_name
    const groups = {1: 'A', 2: 'B', 3: 'C', 4: 'D'};
    return groups[group] || '';
}

function getTournamentRoundName(tournamentRounds, matchRound, group) {  // Previously get_tournament_round_name
    if (group !== null) {
        return `Round ${matchRound}`;
    }
    const rounds = {0: 'Final', 1: 'Semi Finals', 2: 'Quarter Finals', 3: 'Round of 16'};
    return rounds[tournamentRounds - matchRound] || `Round ${matchRound}`
}

function getMatchHype(match) {  // Previously get_match_hype
    try {
        return match.hype + match.streakBonus + match.eventBonus + match.contractBonus + match.tournamentFinalBonus
    }
    catch (error) {
        return match.hype
    }
}

async function getMatchEventTitle(match) {  // Previously get_match_event_title
    const event = await getMatchEvent(match);
    return getEventTitle(event);
}

async function getMatchHandicapSize(matchParticipants) {
    let handicapSize = [];
    for (const matchParticipant of matchParticipants) {
        const matchParticipantSuperstars = await getTagTeamSuperstars(matchParticipant);
        handicapSize.push(matchParticipantSuperstars.length)
    }
    return handicapSize;
}

async function getMatchRefereeSuperstar(match, rosterSuperstars = null) {  // Previously getMatchRefereeSuperstar
    let refereeSuperstar = null;
    if (match.refereeId) {
        if (rosterSuperstars) {
            refereeSuperstar = rosterSuperstars.find(x => x.$loki === match.refereeId)
        }
        else {
            refereeSuperstar = await Superstars.get(match.refereeId)
        }
    }
    return refereeSuperstar;
}

async function getMatchHistoryData(match) {  // get_match_data
    let matchData = {};
    let matchGimmick = await getMatchGimmickMatch(match);
    const matchTournament = await getMatchTournament(match);

    // Get winner data
    let winnerDict = {};
    winnerDict.name = match.winner;
    winnerDict.championshipsWon = match.championshipsWon;
    winnerDict.championshipsDefended = match.championshipsDefended;
    winnerDict.championshipsRetained = match.championshipsRetained;
    matchData['winner'] = winnerDict;

    // Get losers data
    let losers;
    if (match.loser) {
        losers = [match.loser]
    }
    else {
        let matchParticipants = (await getMatchParticipants(match)).reverse().map(x => x.name);
        losers = matchParticipants.filter(x => x !== match.winner)
    }
    matchData['losers'] = losers;

    // Get other data
    matchData['rating'] = match.rating;
    matchData['text'] = match.generatedText;
    matchData['event'] = await getMatchEventTitle(match);
    matchData['gimmick'] = (matchGimmick) ? matchGimmick.name : '';
    matchData['finishName'] = match.finishName;

    // Get tournament data
    if (matchTournament) {
        matchData['tournamentName'] = matchTournament.name;
        matchData['tournamentGroup'] = getTournamentGroupName(match.tournamentGroup);
        matchData['tournamentRoundName'] = getTournamentRoundName(matchTournament.rounds, match.tournamentRound,
            match.tournamentGroup);
    }

    return matchData;
}

async function getMatchName(match) {  // get_match_name
    const participants = await getMatchParticipants(match);
    let participantNames;
    if (participants.length > 10) {
        participantNames = participants.slice(0, 10).map(x => x.name);
        let others = participants.length - 10;
        let othersWord = others !== 1 ? 'others' : 'other';
        participantNames.push(`${others} ${othersWord}`)
    }
    else {
        participantNames = participants.map(x => x.name)
    }
    return participantNames.join(' vs ');
}

async function deleteCompanyMatch({uid} = {}) {  // delete_match_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const staffMembers = await getCompanyStaff(userCompany);
    const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');
    const match = await Matches.get(uid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Don't allow deleting 'Femme Fatale' match at premier event in POW
    if (userCompany.storyName === 'passion') {
        const matchGimmick = await getMatchGimmickMatch(match);
        const sponsorGoal = (await getCompanyObjectives(userCompany)).find(x => x.name === 'Get some Sponsors');
        if (!sponsorGoal.completed && !sponsorGoal.failed && matchGimmick && matchGimmick.name === 'Femme Fatale') {
            data['error'] = 'pow-cannot-delete';
            return data;
        }
    }

    // Delete match
    let deleteData = await deleteMatch(match, userCompany);
    let numberOfMatchesDeleted = deleteData[0];
    let tournament = deleteData[1];
    data['deletedPotentialFeudUids'] = deleteData[2];

    // Subtract from event's matchesCount
    latestEvent.matchesCount -= numberOfMatchesDeleted;

    // Check for tournament weekly show
    if (tournament && latestEvent.name === 'Weekly Show') {
        data['weeklyShowDeleted'] = true;

        // Delete event
        const eventMatches = await getEventMatches(latestEvent);
        const eventSegments = await getEventSegments(latestEvent);
        for (const match of eventMatches) {
            await deleteMatch(match, userCompany);
        }
        for (const segment of eventSegments) {
            await deleteSegment(segment, producers);
        }
        await Events.remove(latestEvent);
    }

    // Reset event's matches and segments order
    let segmentsAndMatches = await getEventMatchesAndSegments(latestEvent);
    segmentsAndMatches.sort((a, b) => a.order - b.order);
    for (const x of segmentsAndMatches) {
        x.order = segmentsAndMatches.indexOf(x);
    }

    db.saveDatabase();

    // Get unbooked (match superstars/tag teams who aren't booked in other matches)
    const bookedSuperstars = await getSuperstarsBookedAtEventMatches(latestEvent);
    const matchSuperstars = deleteData[3];
    data['unbookedMatchSuperstarsUids'] = matchSuperstars.filter(x => !objectInArray(x, bookedSuperstars)).map(x => x.$loki);

    // Get data to return
    data['points'] = userCompany.points;

    return data;
}

async function getSuperstarsBookedAtEventMatches(event) {
    // Includes superstars in singles and tag matches
    const superstarsBooked = [];
    const matches = await getEventMatches(event);
    for (const x of matches) {
        superstarsBooked.push(...(await getAllSuperstarsForMatch(x)))
    }
    return getUniqueObjects(superstarsBooked);
}

async function deleteMatch(match, company) {
    let matches = [match];
    let tournament = await getMatchTournament(match);
    if (tournament) {
        // Delete tournament's matches
        matches = await getTournamentMatches(tournament);
        company.points += tournament.cost;
        await Tournaments.remove(tournament);
    }
    let numberOfMatchesDeleted = matches.length;
    let companyChampionships = await getCompanyChampionships(company);
    let deletedPotentialFeudUids = [];
    let matchSuperstars = [];
    let matchTagTeams = [];

    for (const match of matches) {
        let matchParticipants = await getMatchParticipants(match);
        let championships = await getMatchChampionships(match);
        let feuds = await getMatchFeuds(match);
        let matchGimmick = await getMatchGimmickMatch(match);

        // Remove temporary tag teams
        for (const p of matchParticipants) {
            for (const s of (await getRosterMemberSuperstars(p))) {
                matchSuperstars.push(s);
            }
            if (p.objectName === 'tagTeam' && p.temporary) {
                await removeTagTeam(p);
            }
            if (p.objectName === 'tagTeam') {
                matchTagTeams.push(p)
            }
        }

        // Process championships
        for (const c of championships) {
            let allChampionships = companyChampionships.filter(x => checkAreChampionshipsEqual(x, c));

            // Check if match contract awarded
            let matchContractAwarded = false;
            for (const x of allChampionships) {
                if (x.matchContract) {
                    let matchContract = await getChampionshipMatchContract(x);
                    if (matchContract && matchContract.awarded) {
                        matchContractAwarded = true;
                        break;
                    }
                }
            }

            for (const x of allChampionships) {
                x.booked = false;

                // Find newly created championship contract and delete it
                if (x.championshipContract) {
                    let reigns = await getChampionshipChampionshipReigns(x);
                    if (reigns.length <= 0) {
                        await Championships.remove(x);
                    }
                }

                // Find newly created match contract and remove it
                if (x.matchContract && !matchContractAwarded) {
                    let matchContract = await getChampionshipMatchContract(x);
                    if (matchContract) {
                        await MatchContracts.remove(matchContract);
                    }
                    await Championships.remove(x);
                }
            }
        }

        // Refund gimmick match points
        if (matchGimmick) {
            company.points += matchGimmick.cost;
        }

        // Refund used powerups
        if (match.activeEffect) {
            let powerup = (await getCompanyPowerups(company)).find(x => x.effect === match.activeEffect);
            if (powerup) {
                powerup.stock += 1;
            }
        }

        // Remove feuds
        for (const feud of feuds) {
            if (feud.started && feud.runBlowoff) {
                feud.runBlowoff = false;
            }
            // Delete potential feuds
            if (!feud.started && !feud.directFeudEvent) {
                await FeudParticipantsHash.findAndRemove({"feudId": feud.$loki});
                deletedPotentialFeudUids.push(feud.$loki);
                await Feuds.remove(feud);
            }
        }

        // Delete match from db
        await FeudMatchesHash.findAndRemove({"matchId": match.$loki});
        await MatchesHash.findAndRemove({"matchId": match.$loki});
        try {
            await Matches.remove(match);
        }
        catch {}
    }

    return [numberOfMatchesDeleted, tournament, deletedPotentialFeudUids, matchSuperstars, matchTagTeams];
}

async function addMatch({participantsData, selectedGimmickMatchUid, selectedGimmickMatchName, selectedChampionshipUid,
                         matchEventUid, gimmickMatchObject, fallGimmickNames, refereeUid, tagTeamSize,
                         handicapSize, singlesTag, matchType, tagMatchOptionSelected} = {}) {

    let data = {};
    try {
        const currentGame = await getCurrentGame();
        const userCompany = await getGameCurrentUserCompany(currentGame);
        const latestEvent = await getCompanyLatestEvent(userCompany);
        const parentEvents = await getCompanyParentEvents(userCompany);
        const eventMatchesAndSegments = await getEventMatchesAndSegments(latestEvent);
        const mainRoster = await getCompanyRosterByType(userCompany, 'main');
        const rosterSuperstars = await getRosterSuperstars(mainRoster);
        const productionFacility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Production');
        const companyChampionships = await getCompanyChampionships(userCompany);

        // Check match/segment limit
        const maximumMatchesAndSegments = getEventMaximumMatchesAndSegments(latestEvent, parentEvents, productionFacility);
        if (eventMatchesAndSegments.length >= maximumMatchesAndSegments) {
            data['error'] = 'match-and-segment-limit';
            data['limit'] = maximumMatchesAndSegments;
            return data;
        }

        // Check for production packages only
        if (latestEvent.activeEffect === 'production_packages_only') {
            data['error'] = 'production-packages-only';
            return data;
        }

        // Get participants
        let matchParticipants = [];
        if (singlesTag) {

            // Get selected superstars
            let superstars = [];
            for (const x of participantsData) {
                let participant = rosterSuperstars.find(y => y.$loki === x.uid);
                // Check participant
                if (!participant) {
                    data['error'] = 'not-found';
                    return data;
                }
                if (objectInArray(participant, matchParticipants)) {
                    data['error'] = 'same';
                    return data;
                }
                superstars.push(participant);
            }

            // Divide superstars into teams
            let teamsData;
            if (handicapSize) {
                // Check max team size
                let maxTeamSize = 10;
                let teamASize = handicapSize[0];
                let teamBSize = handicapSize[1];
                if (teamASize > maxTeamSize || teamBSize > maxTeamSize) {
                    data['error'] = 'max-team-size';
                    data['maxTeamSize'] = maxTeamSize;
                    return data;
                }
                // Split superstars into chunks using handicap size
                teamsData = [superstars.slice(0, teamASize), superstars.slice(teamASize, teamASize + teamBSize)];
            } else {
                // Check max team size
                let maxTeamSize = 5;
                if (tagTeamSize > maxTeamSize) {
                    data['error'] = 'max-team-size';
                    data['maxTeamSize'] = maxTeamSize;
                    return data;
                }
                // Split superstars into chunks of team size
                teamsData = getChunks(superstars, tagTeamSize);
            }

            for (const teamSuperstars of teamsData) {
                // Find existing tag team
                let existingTagTeam;
                for (const tagTeam of (await getSuperstarTagTeams(teamSuperstars[0]))) {
                    if (checkAreObjArraysEqual((await getTagTeamSuperstars(tagTeam)), teamSuperstars)) {
                        existingTagTeam = tagTeam;
                        break;
                    }
                }
                if (existingTagTeam) {
                    matchParticipants.push(existingTagTeam)
                } else {
                    // Find existing faction
                    let existingFaction;
                    for (const faction of (await getSuperstarActiveFactions(teamSuperstars[0]))) {
                        let factionSuperstars = await getFactionSuperstars(faction);
                        if (teamSuperstars.every(s => objectInArray(s, factionSuperstars))) {
                            existingFaction = faction;
                            break;
                        }
                    }

                    // Get team name. Use faction name if found.
                    let teamName;
                    if (existingFaction) {
                        if (checkAreObjArraysEqual((await getFactionSuperstars(existingFaction)), teamSuperstars)) {
                            teamName = existingFaction.name;
                        } else {
                            let teamSuperstarsNames = commaSeparate([...teamSuperstars]
                                .sort((a, b) => a.$loki - b.$loki).map(y => getSuperstarLastName(y)));
                            teamName = `${existingFaction.name} (${teamSuperstarsNames})`;
                        }
                    } else {
                        teamName = commaSeparate([...teamSuperstars].sort((a, b) => a.$loki - b.$loki).map(y => y.name));
                    }

                    // Create temporary tag team
                    const newTagTeam = TagTeam(teamName, true);
                    await TagTeams.insert(newTagTeam);
                    await addTagTeamSuperstars(newTagTeam, teamSuperstars);
                    await addRosterTagTeams(mainRoster, [newTagTeam]);
                    matchParticipants.push(newTagTeam);
                }
            }
        } else {
            for (const x of participantsData) {
                let participant;
                if (x.type === 'superstar') {
                    participant = rosterSuperstars.find(y => y.$loki === x.uid);
                } else if (x.type === 'tag-team' || x.type === 'trio') {
                    participant = await TagTeams.get(x.uid);
                } else if (x.type === 'faction') {
                    participant = await Factions.get(x.uid);
                }

                // Check participant
                if (!participant) {
                    data['error'] = 'not-found';
                    return data;
                }
                if (objectInArray(participant, matchParticipants)) {
                    data['error'] = 'same';
                    return data;
                }

                // If faction selected or trio selected in tag match, create temporary tag team
                if (participant.objectName === 'faction' || (participant.trio && tagMatchOptionSelected === 'Tag')) {
                    let teamSuperstars = await getRosterMemberSuperstars(participant);
                    let availableTeamSuperstars = teamSuperstars.filter(y => checkAvailability(y, false)
                        && checkSuperstarBrandAvailability(latestEvent, y,
                            getSuperstarChampionshipsFromCompanyChampionships(y, companyChampionships)));
                    // Check if enough team superstars available
                    let minimumAvailableSuperstars = tagMatchOptionSelected === 'Trio' ? 3 : 2;
                    if (availableTeamSuperstars.length < minimumAvailableSuperstars) {
                        data['error'] = 'not-available';
                        return data;
                    }

                    // Create temporary tag team
                    let temporaryTeamSuperstars = getRandomSample(availableTeamSuperstars, minimumAvailableSuperstars);
                    let temporaryTeamSuperstarsNames = commaSeparate([...temporaryTeamSuperstars]
                        .sort((a, b) => a.$loki - b.$loki).map(y => getSuperstarLastName(y)));
                    let teamName = `${participant.name} (${temporaryTeamSuperstarsNames})`;
                    const newTagTeam = TagTeam(teamName, true);
                    if (participant.objectName === 'tagTeam') {
                        newTagTeam.trioTagTeam = true;
                    } else if (participant.objectName === 'faction') {
                        newTagTeam.factionTagTeam = true;
                    }
                    await TagTeams.insert(newTagTeam);
                    await addTagTeamSuperstars(newTagTeam, temporaryTeamSuperstars);
                    await addRosterTagTeams(mainRoster, [newTagTeam]);
                    matchParticipants.push(newTagTeam);
                } else {
                    matchParticipants.push(participant);
                }
            }
        }

        // Get participant superstars
        let participantSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();

        // Check if any superstars are present twice
        for (const s of participantSuperstars) {
            if (participantSuperstars.filter(x => x.$loki === s.$loki).length > 1) {
                data['error'] = 'duplicate-superstar';
                data['duplicateSuperstar'] = s.name;
                return data;
            }
        }

        // Check for booking restrictions on event
        let eventActiveEffect = latestEvent.activeEffect;
        if (['no_women_bookable', 'no_men_bookable'].includes(eventActiveEffect)) {
            for (const s of participantSuperstars) {
                if (eventActiveEffect === 'no_women_bookable' && s.gender === 'female') {
                    data['error'] = 'no-women-allowed';
                    return data;
                } else if (eventActiveEffect === 'no_men_bookable' && s.gender === 'male') {
                    data['error'] = 'no-men-allowed';
                    return data;
                }
            }
        }

        // Get gimmick match data
        let gimmickMatch;
        let matchChampionship;
        let generatedObject;
        let generatedLocation;
        if (selectedGimmickMatchUid) {

            // Get gimmick match
            gimmickMatch = await GimmickMatches.get(selectedGimmickMatchUid);
            if (!gimmickMatch) {
                data['error'] = 'gimmick-match-not-found';
                return data;
            }

            // Get custom object/location
            if (gimmickMatchObject) {
                if (selectedGimmickMatchName === 'Brawl') {
                    generatedLocation = 'Arena'
                } else if (selectedGimmickMatchName === 'Pole') {
                    generatedObject = 'Chair'
                } else {
                    let gimmickMatchNameWords = selectedGimmickMatchName.split(' ');
                    if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === 'Brawl') {
                        generatedLocation = selectedGimmickMatchName.split(' Brawl')[0]
                    } else if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === 'Pole') {
                        generatedObject = selectedGimmickMatchName.split(' on a Pole')[0]
                    }
                }
            }

            // Check gimmick match
            if (userCompany.points < gimmickMatch.cost) {
                data['error'] = 'points';
                return data;
            }
            if (gimmickMatch.rules === '2/3_falls' && matchParticipants.length > 2) {
                data['error'] = '2/3-falls-one-on-one';
                return data;
            }
            if (['remove_hair', 'add_hair', 'remove_mask', 'remove_mask_or_hair'].includes(gimmickMatch.consequence)) {
                if (participantSuperstars.some(x => !x.graphic || Object.keys(x.graphic).length === 0 ||
                    x.graphic['empty_graphic'])) {
                    data['error'] = 'graphics-not-present';
                    return data;
                }
                if (gimmickMatch.consequence === 'remove_hair') {
                    if (participantSuperstars.some(x => x.graphic['hair']['object'] === 0)) {
                        data['error'] = 'hair-not-present';
                        return data;
                    }
                }
                if (gimmickMatch.consequence === 'add_hair') {
                    if (participantSuperstars.some(x => x.graphic['hair']['object'] !== 0)) {
                        data['error'] = 'hair-present';
                        return data;
                    }
                }
                if (gimmickMatch.consequence === 'remove_mask') {
                    if (participantSuperstars.some(x => !checkSuperstarGraphicMask(x.graphic))) {
                        data['error'] = 'mask-not-present';
                        return data;
                    }
                }
                if (gimmickMatch.consequence === 'remove_mask_or_hair') {
                    let superstarsWithMask = participantSuperstars.filter(x => checkSuperstarGraphicMask(x.graphic));
                    let superstarsWithHair = participantSuperstars.filter(x => x.graphic['hair']['object'] !== 0 &&
                        !objectInArray(x, superstarsWithMask));
                    if (superstarsWithMask.length <= 0 || superstarsWithHair.length <= 0) {
                        data['error'] = 'mask-and-hair-not-present';
                        return data;
                    }
                }
            }
            // TODO LATER test
            if (userCompany.storyName === 'mars' && gimmickMatch.name === 'Olympus Mons') {
                for (const match of (await getEventMatches(latestEvent))) {
                    let matchGimmick = await getMatchGimmickMatch(match);
                    if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) {
                        data['error'] = 'olympus-mons-already-booked';
                        return data;
                    }
                }
            }

            // Create contract championships
            if (gimmickMatch.cashinContractName) {
                // Check for existing championship
                let existingCashinChampionship = companyChampionships
                    .find(x => x.name === gimmickMatch.cashinContractName && x.championshipContract);
                if (existingCashinChampionship && existingCashinChampionship.monthsToExpire !== 0) {
                    data['error'] = 'cashin-contract-exists';
                    return data;
                }
                matchChampionship = await createCashinContractChampionship(gimmickMatch, matchParticipants,
                    userCompany);
            }
            if (gimmickMatch.matchContractName) {
                let existingMatchContractChampionship = companyChampionships
                    .find(x => x.name === gimmickMatch.matchContractName && x.matchContract);
                if (existingMatchContractChampionship) {
                    data['error'] = 'match-contract-exists';
                    return data;
                }
                matchChampionship = await createMatchContractChampionship(gimmickMatch, matchParticipants, userCompany,
                    matchEventUid);
            }
        }

        // Check for women only gimmick match
        let womenOnlyGimmickMatch = gimmickMatch && gimmickMatch.name === 'Femme Fatale' && gimmickMatch.special;
        if (womenOnlyGimmickMatch && participantSuperstars.some(x => x.gender === 'male')) {
            data['error'] = 'femme-fatale-men';
            return data;
        }

        // Get match championship if not created and not handicap match
        if (!matchChampionship && !handicapSize) {
            if (selectedChampionshipUid) {
                // Get vacant championship
                matchChampionship = companyChampionships.find(x => x.$loki === selectedChampionshipUid);
                if (!matchChampionship) {
                    data['error'] = 'championship-not-found';
                    return data;
                }

                // Check for gimmick restriction
                if (!checkChampionshipGimmickRestriction(matchChampionship, gimmickMatch, latestEvent, participantSuperstars)) {
                    data['error'] = 'gimmick-restriction';
                    data['gimmickRestrictedChampionship'] = {
                        'name': getChampionshipDisplayName(matchChampionship),
                        'gimmickRestriction': matchChampionship.gimmickRestriction
                    };
                    return data;
                }
            } else {
                // Get participants' championship
                let matchChampionshipsData = await getMatchAvailableChampionships(matchParticipants,
                    participantSuperstars, companyChampionships, gimmickMatch, latestEvent, true);
                if (matchChampionshipsData['availableChampionships'].length > 0) {
                    matchChampionship = matchChampionshipsData['availableChampionships'][0];
                }
                data['gimmickRestrictedChampionships'] = matchChampionshipsData['gimmickRestrictedChampionships'];
            }
        }

        // Create match
        const newMatch = Match(latestEvent.matchesCount, matchType);
        await Matches.insert(newMatch);
        await addEventMatches(latestEvent, [newMatch]);
        latestEvent.matchesCount += 1;

        // Add participants
        await addMatchParticipants(newMatch, matchParticipants);

        // Add championship
        if (matchChampionship) {
            await addMatchChampionships(newMatch, [matchChampionship]);
            for (const c of (await getCompanyChampionships(userCompany))
                .filter(x => checkAreChampionshipsEqual(x, matchChampionship))) {
                c.booked = true;
            }
        }

        // Add gimmick match and its data
        if (gimmickMatch) {
            await addGimmickMatchMatches(gimmickMatch, [newMatch]);
            userCompany.points -= gimmickMatch.cost;

            // Add custom object or location
            if (gimmickMatch.generateObject) {
                newMatch.objectToClaim = generatedObject
            }
            if (gimmickMatch.generateLocation) {
                newMatch.location = generatedLocation
            }
            // Add fall names
            if (gimmickMatch.rules === '2/3_falls' && fallGimmickNames) {
                newMatch.fallGimmickNames = fallGimmickNames
            }
            // Add referee id
            if (gimmickMatch.rules === 'special_referee' && refereeUid) {
                let refereeSuperstar = await Superstars.get(refereeUid);
                if (objectInArray(refereeSuperstar, participantSuperstars)) {
                    data['error'] = 'referee-in-match';
                    return data;
                }
                newMatch.refereeId = refereeSuperstar.$loki;
            }
        }

        // Get all superstars and teams present
        let tagTeamsPresent = [];
        for (const s of participantSuperstars) {
            tagTeamsPresent.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
        }
        tagTeamsPresent = getUniqueObjects(tagTeamsPresent);

        // Find existing feuds and add to match
        let matchFeuds = await getParticipantFeuds(participantSuperstars, tagTeamsPresent);
        await addMatchFeuds(newMatch, matchFeuds);

        // Start direct feuds
        for (const feud of matchFeuds) {
            if (!feud.started && feud.directFeudEvent && !feud.ended) {
                feud.startMonth = currentGame.monthCount;
                feud.startYear = currentGame.year;
                feud.runBlowoff = false;
            }
        }

        // Reset attires
        for (const s of participantSuperstars) {
            if (s.currentAttire > 0) {
                s.currentAttire = 0
            }
        }

        // Add managers
        if (globalUser.paid) {
            setManagersForMatchOrSegment(newMatch, participantSuperstars, rosterSuperstars, latestEvent)
        }

        // Check tutorial action
        if (userCompany.storyName === 'tutorial') {
            if (matchType === 'singles') {
                data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['add_singles_match',
                    'book_feud_match']);
            }
            else {
                data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['add_tag_match',
                    'add_vacant_title_match']);
            }
        }

        db.saveDatabase();

        // Get data to return
        data['match'] = await getMatchData({
            match: newMatch, companyChampionships: companyChampionships,
            rosterSuperstars: rosterSuperstars
        });
        data['points'] = userCompany.points;
        data['alignmentBoost'] = await getAlignmentBoost(matchParticipants, userCompany.style);
    }
    finally {
        if (data['error']) {
            await loadDb(db.filename);
        }
    }

    return data;
}

async function getAlignmentBoost(participants, style = 'entertainment') {  // get_alignment_boost
    let alignmentBoost = 0;
    let defaultBoost = style === 'pure' ? 5 : 10;
    let traitBoost = 0;

    if (participants.length <= 0) {
        return alignmentBoost;
    }

    let faces = [];
    let heels = [];
    let faceAlignmentBoost = 0;
    let heelAlignmentBoost = 0;
    let traitPenalty = 0;
    for (const x of participants) {
        // Get faces and heels
        let participantSuperstars = await getRosterMemberSuperstars(x);
        if (participantSuperstars.every(x => x.alignment === 'face')) {
            faces.push(x)
        }
        else if (participantSuperstars.every(x => x.alignment === 'heel')) {
            heels.push(x)
        }

        // Get traits that affect alignment boost
        for (const superstar of participantSuperstars) {
            for (const trait of superstar.traits) {
                let traitData = traitsData[trait];
                if (traitData) {
                    if (superstar.alignment === 'face') {
                        if (traitData['face_alignment_hype_boost']) {
                            faceAlignmentBoost += traitData['face_alignment_hype_boost'];
                        }
                        if (traitData['face_alignment_penalty']) {
                            traitPenalty += traitData['face_alignment_penalty'];
                        }
                    }
                    else if (superstar.alignment === 'heel') {
                        if (traitData['heel_alignment_hype_boost']) {
                            heelAlignmentBoost += traitData['heel_alignment_hype_boost'];
                        }

                        if (traitData['heel_alignment_penalty']) {
                            traitPenalty += traitData['heel_alignment_penalty'];
                        }
                    }
                }
            }
        }
    }

    // Face vs heel
    if (faces.length > 0 && heels.length > 0) {
        faceAlignmentBoost = limitValueBetweenRange(faceAlignmentBoost, 0, 10);
        heelAlignmentBoost = limitValueBetweenRange(heelAlignmentBoost, 0, 10);
        traitBoost += faceAlignmentBoost + heelAlignmentBoost;
        traitBoost = limitValueBetweenRange(traitBoost, 0, 20);
        if (style === 'pure') {
            traitBoost /= 2
        }
        alignmentBoost += defaultBoost + traitBoost;
    }
    // Heel vs heel
    else if (heels.length > 1) {
        traitBoost -= heelAlignmentBoost;
        traitBoost = limitValueBetweenRange(traitBoost, -20, 0);
        if (style === 'pure') {
            traitBoost /= 2
        }
        alignmentBoost -= defaultBoost - traitBoost;
    }
    // Face vs face
    else if (faces.length > 1) {
        traitBoost += faceAlignmentBoost / 2;
        traitBoost = limitValueBetweenRange(traitBoost, 0, 10);
        if (style === 'pure') {
            traitBoost /= 2
        }
        alignmentBoost += defaultBoost / 2 + traitBoost;
    }

    // Add trait alignment penalty
    traitPenalty = limitValueBetweenRange(traitPenalty, -30, 0);
    alignmentBoost += traitPenalty;

    return alignmentBoost;
}

async function createCashinContractChampionship(gimmickMatch, matchParticipants, company) {
    // Get number of championships to create
    let numberOfChampionships = 1;
    if (matchParticipants[0].objectName === 'tagTeam') {
        if (matchParticipants[0].trio) {
            numberOfChampionships = 3
        }
        else {
            numberOfChampionships = 2
        }
    }

    // Create championships
    let createdChampionships = [];
    for (const x of Array(numberOfChampionships).keys()) {
        const newChampionship = Championship(gimmickMatch.cashinContractName);
        newChampionship.championshipContract = true;
        newChampionship.monthsToExpire = gimmickMatch.monthsToExpire ? gimmickMatch.monthsToExpire : 12;
        newChampionship.vacated = true;
        newChampionship.rank = 'Upper Midcarder';
        if (numberOfChampionships === 2) {
            newChampionship.tagTeam = true;
        }
        else if (numberOfChampionships === 3) {
            newChampionship.trio = true;
        }
        await Championships.insert(newChampionship);
        createdChampionships.push(newChampionship);
    }

    // Add to company
    await addCompanyChampionships(company, createdChampionships);

    return createdChampionships[0];
}

async function createMatchContractChampionship(gimmickMatch, matchParticipants, company, matchEventUid) {
    let bonuses = {'C': 12, 'B': 25, 'A': 50};
    let parentEvent = await Events.get(matchEventUid);

    // Create match contract
    let matchContract = MatchContract();
    matchContract.name = gimmickMatch.matchContractName;
    matchContract.awarded = false;
    matchContract.bonus = bonuses[parentEvent.prestige];
    await MatchContracts.insert(matchContract);

    // Add match contract to parent event
    await addEventMatchContracts(parentEvent, [matchContract]);
    // Get number of championships to create
    let numberOfChampionships = 1;
    if (matchParticipants[0].objectName === 'tagTeam') {
        if (matchParticipants[0].trio) {
            numberOfChampionships = 3
        }
        else {
            numberOfChampionships = 2
        }
    }

    // Create championships
    let createdChampionships = [];
    for (const x of Array(numberOfChampionships).keys()) {
        const newChampionship = Championship(gimmickMatch.matchContractName);
        newChampionship.matchContract = true;
        newChampionship.vacated = true;
        newChampionship.rank = 'Upper Midcarder';
        if (numberOfChampionships === 2) {
            newChampionship.tagTeam = true;
        }
        else if (numberOfChampionships === 3) {
            newChampionship.trio = true;
        }
        await Championships.insert(newChampionship);
        await addChampionshipMatchContracts(newChampionship, [matchContract]);
        createdChampionships.push(newChampionship);
    }

    // Add to company
    await addCompanyChampionships(company, createdChampionships);

    return createdChampionships[0];
}

async function addGimmickMatchToMatch({matchUid, gimmickMatchUid, gimmickMatchName, matchEventUid, gimmickMatchObject,
                                       fallGimmickNames, refereeUid} = {}) {  // add_gimmick_match_to_match

    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(userCompany);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    // Get match and participants
    let match = await Matches.get(matchUid);
    let matchParticipants = await getMatchParticipants(match);
    let participantSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();

    // Get gimmick match
    let gimmickMatch = await GimmickMatches.get(gimmickMatchUid);
    if (!gimmickMatch) {
        data['error'] = 'gimmick-match-not-found';
        return data;
    }

    // Check gimmick match
    if (userCompany.points < gimmickMatch.cost) {
        data['error'] = 'points';
        return data;
    }
    if (gimmickMatch.rules === '2/3_falls' && matchParticipants.length > 2) {
        data['error'] = '2/3-falls-one-on-one';
        return data;
    }
    if (['remove_hair', 'add_hair', 'remove_mask', 'remove_mask_or_hair'].includes(gimmickMatch.consequence)) {
        if (participantSuperstars.some(x => !x.graphic || Object.keys(x.graphic).length === 0 ||
            x.graphic['empty_graphic'])) {
            data['error'] = 'graphics-not-present';
            return data;
        }
        if (gimmickMatch.consequence === 'remove_hair') {
            if (participantSuperstars.some(x => x.graphic['hair']['object'] === 0)) {
                data['error'] = 'hair-not-present';
                return data;
            }
        }
        if (gimmickMatch.consequence === 'add_hair') {
            if (participantSuperstars.some(x => x.graphic['hair']['object'] !== 0)) {
                data['error'] = 'hair-present';
                return data;
            }
        }
        if (gimmickMatch.consequence === 'remove_mask') {
            if (participantSuperstars.some(x => !checkSuperstarGraphicMask(x.graphic))) {
                data['error'] = 'mask-not-present';
                return data;
            }
        }
        if (gimmickMatch.consequence === 'remove_mask_or_hair') {
            let superstarsWithMask = participantSuperstars.filter(x => checkSuperstarGraphicMask(x.graphic));
            let superstarsWithHair = participantSuperstars.filter(x => x.graphic['hair']['object'] !== 0 &&
                !objectInArray(x, superstarsWithMask));
            if (superstarsWithMask.length <= 0 || superstarsWithHair.length <= 0) {
                data['error'] = 'mask-and-hair-not-present';
                return data;
            }
        }
    }
    let womenOnlyGimmickMatch = gimmickMatch.name === 'Femme Fatale' && gimmickMatch.special;
    if (womenOnlyGimmickMatch && participantSuperstars.some(x => x.gender === 'male')) {
        data['error'] = 'femme-fatale-men';
        return data;
    }
    // TODO LATER test
    if (userCompany.storyName === 'mars' && gimmickMatch.name === 'Olympus Mons') {
        const latestEvent = await getCompanyLatestEvent(userCompany);
        for (const match of (await getEventMatches(latestEvent))) {
            let matchGimmick = await getMatchGimmickMatch(match);
            if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) {
                data['error'] = 'olympus-mons-already-booked';
                return data;
            }
        }
    }

    // Get referee
    let refereeSuperstar;
    if (gimmickMatch.rules === 'special_referee' && refereeUid) {
        refereeSuperstar = await Superstars.get(refereeUid);
        if (objectInArray(refereeSuperstar, participantSuperstars)) {
            data['error'] = 'referee-in-match';
            return data;
        }
    }

    // Create contract championships
    let matchChampionship;
    if (gimmickMatch.cashinContractName) {
        if (matchParticipants.length <= 0) {
            data['error'] = 'no-participants';
            return data;
        }
        // Check for existing championship
        let existingCashinChampionship = companyChampionships
            .find(x => x.name === gimmickMatch.cashinContractName && x.championshipContract);
        if (existingCashinChampionship && existingCashinChampionship.monthsToExpire !== 0) {
            data['error'] = 'cashin-contract-exists';
            return data;
        }
        matchChampionship = await createCashinContractChampionship(gimmickMatch, matchParticipants,
            userCompany);
    }
    if (gimmickMatch.matchContractName) {
        if (matchParticipants.length <= 0) {
            data['error'] = 'no-participants';
            return data;
        }
        let existingMatchContractChampionship = companyChampionships
            .find(x => x.name === gimmickMatch.matchContractName && x.matchContract);
        if (existingMatchContractChampionship) {
            data['error'] = 'match-contract-exists';
            return data;
        }
        matchChampionship = await createMatchContractChampionship(gimmickMatch, matchParticipants, userCompany,
            matchEventUid);
    }

    // Add gimmick match to match
    await addGimmickMatchMatches(gimmickMatch, [match]);

    // Add championship
    if (matchChampionship) {
        await addMatchChampionships(match, [matchChampionship]);
        for (const c of (await getCompanyChampionships(userCompany))
            .filter(x => checkAreChampionshipsEqual(x, matchChampionship))) {
            c.booked = true;
        }
    }

    // Get custom object/location
    let generatedObject;
    let generatedLocation;
    if (gimmickMatchObject) {
        if (gimmickMatchName === 'Brawl') {
            generatedLocation = 'Arena'
        }
        else if (gimmickMatchName === 'Pole') {
            generatedObject = 'Chair'
        }
        else {
            let gimmickMatchNameWords = gimmickMatchName.split(' ');
            if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === 'Brawl') {
                generatedLocation = gimmickMatchName.split(' Brawl')[0]
            }
            else if (gimmickMatchNameWords[gimmickMatchNameWords.length - 1] === 'Pole') {
                generatedObject = gimmickMatchName.split(' on a Pole')[0]
            }
        }
    }

    // Add custom object or location
    if (gimmickMatch.generateObject) {
        match.objectToClaim = generatedObject
    }
    if (gimmickMatch.generateLocation) {
        match.location = generatedLocation
    }
    // Add fall names
    if (gimmickMatch.rules === '2/3_falls' && fallGimmickNames) {
        match.fallGimmickNames = fallGimmickNames
    }
    // Add referee
    if (refereeSuperstar) {
        match.refereeId = refereeSuperstar.$loki;
    }

    // Subtract points
    userCompany.points -= gimmickMatch.cost;

    // Check tutorial action
    if (userCompany.storyName === 'tutorial') {
        data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['add_gimmick_to_match']);
    }

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match: match, companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars});
    data['points'] = userCompany.points;

    return data;
}

async function changeMatchOrSegmentOrder({uid, objectName, position} = {}) {  // change_segment_order
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const segmentsAndMatches = await getEventMatchesAndSegments(latestEvent);
    segmentsAndMatches.sort((a, b) => a.order - b.order);

    // Get match or segment
    let matchOrSegment = segmentsAndMatches.find(x => x.$loki === uid && x.objectName === objectName);

    // Reorder other matches and segments
    for (const x of segmentsAndMatches) {
        if (x !== matchOrSegment) {
            if (position <= x.order && x.order < matchOrSegment.order) {
                x.order += 1
            }
            else if (matchOrSegment.order < x.order && x.order <= position) {
                x.order -= 1
            }
        }
    }

    // Change order or selected match or segment
    matchOrSegment.order = position;

    // Check tutorial action
    if (userCompany.storyName === 'tutorial') {
        data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['move_to_main_event']);
    }

    db.saveDatabase();

    return data;
}

async function removeChampionshipFromMatch({matchUid} = {}) {  // remove_championship_from_match
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);

    // Remove match's championships
    let matchChampionships = await getMatchChampionships(match);
    for (const championship of matchChampionships) {
        await removeMatchChampionships(match, [championship]);
        for (const x of companyChampionships.filter(y => checkAreChampionshipsEqual(y, championship))) {
            x.booked = false;
        }
    }

    db.saveDatabase();

    // Get data to return
    data['championshipUid'] = matchChampionships[0].$loki;

    return data;
}

async function getMatchChampionshipsForSelection({matchUid} = {}) {  // show_match_championships_for_selection
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);

    // Get available championships
    let matchParticipants = (await getMatchParticipants(match)).reverse();
    let matchSuperstars = await getAllSuperstarsForMatch(match);
    let trio = (matchParticipants.length > 0) ? (await getTagTeamSuperstars(matchParticipants[0])).length === 3 : false;
    let matchGimmick = await getMatchGimmickMatch(match);
    let matchEvent = await getMatchEvent(match);
    let availableChampionshipsData = await getMatchAvailableChampionships(matchParticipants, matchSuperstars,
            companyChampionships, matchGimmick, matchEvent);
    let availableChampionships = availableChampionshipsData['availableChampionships'];
    availableChampionships.push(...getVacatedChampionshipsForMatch(match, companyChampionships, trio));

    // If match championships not all in available championships (e.g match to award match contract), add to it
    let matchChampionships = await getMatchChampionships(match);
    for (const championship of matchChampionships) {
        if (!objectInArray(championship, availableChampionships)) {
            availableChampionships.push(championship);
        }
    }

    // Get data to return
    data['championships'] = [];
    let matchChampionshipNames = matchChampionships.map(x => x.name);
    for (const c of availableChampionships) {
        data['championships'].push(
            {'name': c.name, 'uid': c.$loki, 'present': matchChampionshipNames.includes(c.name)}
        )
    }

    return data;
}

async function changeMatchChampionships({matchUid, selectedChampionshipsUids} = {}) {  // change_match_championships
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);

    // Get championships to add
    let championshipsToAdd = [];
    for (const x of selectedChampionshipsUids) {
        let championship = await Championships.get(x);
        if (championship) {
            championshipsToAdd.push(championship);
        }
    }

    // Check for gimmick restriction / booked
    let matchGimmick = await getMatchGimmickMatch(match);
    let matchEvent = await getMatchEvent(match);
    let matchSuperstars = await getAllSuperstarsForMatch(match);
    let matchChampionships = await getMatchChampionships(match);
    for (const x of championshipsToAdd) {
        if (!checkChampionshipGimmickRestriction(x, matchGimmick, matchEvent, matchSuperstars)) {
            data['error'] = 'gimmick-restriction';
            data['gimmickRestrictedChampionship'] = {
                'name': getChampionshipDisplayName(x),
                'gimmickRestriction': x.gimmickRestriction
            };
            return data;
        }
        if (x.booked && !objectInArray(x, matchChampionships)) {
            data['error'] = 'already-booked';
            data['championshipName'] = getChampionshipDisplayName(x);
            data['championshipTag'] = x.tagTeam || x.trio;
            return data;
        }
    }

    // Remove match's championships
    for (const championship of matchChampionships) {
        await removeMatchChampionships(match, [championship]);
        for (const x of companyChampionships.filter(y => checkAreChampionshipsEqual(y, championship))) {
            x.booked = false;
        }
    }

    // Add championships to match
    for (const championship of championshipsToAdd) {
        await addMatchChampionships(match, [championship]);
        for (const x of companyChampionships.filter(y => checkAreChampionshipsEqual(y, championship))) {
            x.booked = true;
        }
    }

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match: match, companyChampionships: companyChampionships});
    data['championships'] = [];
    for (const x of championshipsToAdd) {
        let championshipData = getChampionshipMatchData(x);
        let championshipHolder = await getChampionshipHolder(x);
        if (championshipHolder) {
            championshipData['holder'] = championshipHolder.name;
        }
        data['championships'].push(championshipData);
    }

    return data;
}

async function getAddMatchManagerSelections({matchUid} = {}) {  // get_add_manager_to_match_selections
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get match participants
    let matchParticipants = await getMatchParticipants(match);
    data['matchParticipants'] = matchParticipants.map(x => {
        return {'name': x.name, 'uid': x.$loki}
    });

    // Get partner superstars
    let partnerSuperstars = [];
    let matchSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();
    for (const superstar of matchSuperstars) {
        let superstarFactions = await getSuperstarActiveFactions(superstar);
        let superstarTagTeams = (await getSuperstarTagTeams(superstar)).filter(x => !x.temporary);
        for (const faction of superstarFactions) {
            partnerSuperstars.push(...(await getFactionSuperstars(faction)));
        }
        for (const tagTeam of superstarTagTeams) {
            partnerSuperstars.push(...(await getTagTeamSuperstars(tagTeam)));
        }
    }

    // Get available superstars
    let availableSuperstars = rosterSuperstars.filter(x => checkSuperstarBrandAvailability(latestEvent, x,
        getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships))
        && !objectInArray(x, matchSuperstars));

    // Get manager selections
    data['managerSelections'] = availableSuperstars.map(x => {
        return {'name': x.name, 'uid': x.$loki, 'partnerSuperstar': objectInArray(x, partnerSuperstars)}
    });
    data['managerSelections'].sort((a, b) => a.name.localeCompare(b.name));

    return data;
}

async function addManagerToMatch({matchUid, participantUid, managerUid} = {}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get participant
    let matchParticipants = await getMatchParticipants(match);
    let participant = matchParticipants.find(x => x.$loki === participantUid);
    if (!participant) {
        data['error'] = 'participant-not-found';
        return data;
    }

    // Get manager
    let manager = rosterSuperstars.find(x => x.$loki === managerUid);
    if (!manager) {
        data['error'] = 'manager-not-found';
        return data;
    }

    // Don't allow if any participant superstar already has manager assigned
    let participantSuperstars = await getRosterMemberSuperstars(participant);
    if (!match.managersUsed) {
        match.managersUsed = {}
    }
    for (const s of participantSuperstars) {
        if (match.managersUsed[String(s.$loki)]) {
            data['error'] = 'manager-assigned';
            data['participantName'] = participant.name;
            return data;
        }
    }

    // Don't allow if manager already managing someone in match or in match superstars
    let matchSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();
    if (Object.values(match.managersUsed).includes(manager.$loki) || objectInArray(manager, matchSuperstars)) {
        data['error'] = 'manager-in-match';
        data['managerName'] = manager.name;
        return data;
    }

    // Check if manager available
    if (!checkSuperstarSegmentAvailability(manager) || !checkSuperstarBrandAvailability(latestEvent, manager,
        getSuperstarChampionshipsFromCompanyChampionships(manager, companyChampionships))) {
        data['error'] = 'manager-not-available';
        data['managerName'] = manager.name;
        return data;
    }

    // Add manager to match
    addSuperstarManagerToMatchOrSegment(match, participantSuperstars[0], manager);

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match: match, companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars});

    return data;
}

async function getRemoveMatchManagerSelections({matchUid} = {}) {  // get_remove_manager_from_match_selections
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get manager selections from match.managersUsed
    data['managerSelections'] = [];
    for (const [superstarUid, managerUid] of Object.entries(match.managersUsed)) {
        let manager = rosterSuperstars.find(x => x.$loki === managerUid);
        if (manager) {
            data['managerSelections'].push({'name': manager.name, 'superstarUid': Number(superstarUid)})
        }
    }
    data['managerSelections'].sort((a, b) => a.name.localeCompare(b.name));

    return data;
}

async function removeManagerFromMatch({matchUid, superstarUid} = {}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get superstar
    let superstar = rosterSuperstars.find(x => x.$loki === superstarUid);
    if (!superstar) {
        data['error'] = 'superstar-not-found';
        return data;
    }

    // Check if superstar's manager is assigned in match
    if (!(match.managersUsed[String(superstar.$loki)])) {
        data['error'] = 'manager-not-assigned';
        return data;
    }

    // Remove manager from match
    removeSuperstarManagerFromMatchOrSegment(match, superstar);

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match: match, companyChampionships: companyChampionships,
        rosterSuperstars: rosterSuperstars});

    return data;
}

async function changeTrioTagTeamMembers({matchUid, teamName, selectedMembers} = {}) {  // _change_trio_tagteam_members
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const companyChampionships = await getCompanyChampionships(userCompany);
    const latestEvent = await getCompanyLatestEvent(userCompany);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get team
    let matchTeams = await getMatchParticipants(match);
    let team = matchTeams.find(x => x.name === teamName);
    if (!team) {
        data['error'] = 'team-not-found';
        return data;
    }

    // Get trio
    let oldMembers = await getTagTeamSuperstars(team);
    let trio = (await getSuperstarTagTeams(oldMembers[0])).find(x => x.trio);

    // Get new members
    let newMembers = [];
    let trioSuperstars = await getTagTeamSuperstars(trio);
    for (const name of selectedMembers) {
        let newMember = trioSuperstars.find(x => x.name === name);
        if (!newMember) {
            data['error'] = 'team-members-not-found';
            return data;
        }
        newMembers.push(newMember);
    }

    // Check new members
    let refereeSuperstar = rosterSuperstars.find(x => x.$loki === match.refereeId);
    for (const x of newMembers) {
        if (!checkAvailability(x, false) || !checkSuperstarBrandAvailability(latestEvent, x,
            getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships))) {
            data['error'] = 'member-not-available';
            data['memberName'] = x.name;
            return data;
        }
        if (refereeSuperstar && refereeSuperstar.$loki === x.$loki) {
            data['error'] = 'referee-in-match';
            return data;
        }
    }

    // Check for booking restrictions on event
    let eventActiveEffect = latestEvent.activeEffect;
    if (['no_women_bookable', 'no_men_bookable'].includes(eventActiveEffect)) {
        for (const s of newMembers) {
            if (eventActiveEffect === 'no_women_bookable' && s.gender === 'female') {
                data['error'] = 'no-women-allowed';
                return data;
            }
            else if (eventActiveEffect === 'no_men_bookable' && s.gender === 'male') {
                data['error'] = 'no-men-allowed';
                return data;
            }
        }
    }

    // Remove old members
    await removeTagTeamSuperstars(team);
    await addTagTeamSuperstars(team, newMembers);

    // Change team name
    let teamSuperstarsNames = commaSeparate(newMembers.sort((a, b) => a.$loki - b.$loki)
        .map(x => getSuperstarLastName(x)));
    team.name = `${trio.name} (${teamSuperstarsNames})`;

    // Remove match's feuds
    let previousMatchFeuds = await getMatchFeuds(match);
    for (const x of previousMatchFeuds) {
        await removeMatchFeud(match, x)
    }

    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(matchTeams.map(x => getRosterMemberSuperstars(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent) {
        tagTeamsPresent.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
    }
    tagTeamsPresent = getUniqueObjects(tagTeamsPresent);

    // Find existing feuds and add to match
    let newMatchFeuds = await getParticipantFeuds(superstarsPresent, tagTeamsPresent);
    await addMatchFeuds(match, newMatchFeuds);

    // Start direct feuds
    for (const feud of newMatchFeuds) {
        if (!feud.started && feud.directFeudEvent && !feud.ended) {
            feud.startMonth = currentGame.monthCount;
            feud.startYear = currentGame.year;
            feud.runBlowoff = false;
        }
    }

    // Reset attires
    for (const s of newMembers) {
        if (s.currentAttire > 0) {
            s.currentAttire = 0
        }
    }

    // Add managers
    if (globalUser.paid) {
        let matchManagersUsed = match.managersUsed;

        setManagersForMatchOrSegment(match, newMembers, rosterSuperstars, latestEvent);

        // Add previously added managers
        updateMatchManagersForMembersChange(match, matchManagersUsed, newMembers, oldMembers, superstarsPresent);
    }

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match, companyChampionships, rosterSuperstars});
    data['alignmentBoost'] = await getAlignmentBoost(matchTeams, userCompany.style);

    // Get unbooked and booker superstars
    const bookedSuperstars = await getSuperstarsBookedAtEventMatches(latestEvent);
    data['unbookedMatchSuperstarsUids'] = oldMembers.filter(x => !objectInArray(x, bookedSuperstars)).map(x => x.$loki);
    data['bookedMatchSuperstarsUids'] = newMembers.map(x => x.$loki);

    return data;
}

async function changeFactionTagTeamMembers({matchUid, teamName, selectedMembers} = {}) {  // _change_faction_tagteam_members
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const companyChampionships = await getCompanyChampionships(userCompany);
    const latestEvent = await getCompanyLatestEvent(userCompany);

    // Get match
    let match = await Matches.get(matchUid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get team
    let matchTeams = await getMatchParticipants(match);
    let team = matchTeams.find(x => x.name === teamName);
    if (!team) {
        data['error'] = 'team-not-found';
        return data;
    }

    // Get faction
    let oldMembers = await getTagTeamSuperstars(team);
    let faction = (await getSuperstarFactions(oldMembers[0])).find(x => !x.disbanded);

    // Get new members
    let newMembers = [];
    let factionSuperstars = await getFactionSuperstars(faction);
    for (const name of selectedMembers) {
        let newMember = factionSuperstars.find(x => x.name === name);
        if (!newMember) {
            data['error'] = 'team-members-not-found';
            return data;
        }
        newMembers.push(newMember);
    }

    // Check new members
    let refereeSuperstar = rosterSuperstars.find(x => x.$loki === match.refereeId);
    for (const x of newMembers) {
        if (!checkAvailability(x, false) || !checkSuperstarBrandAvailability(latestEvent, x,
            getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships))) {
            data['error'] = 'member-not-available';
            data['memberName'] = x.name;
            return data;
        }
        if (refereeSuperstar && refereeSuperstar.$loki === x.$loki) {
            data['error'] = 'referee-in-match';
            return data;
        }
    }

    // Check for booking restrictions on event
    let eventActiveEffect = latestEvent.activeEffect;
    if (['no_women_bookable', 'no_men_bookable'].includes(eventActiveEffect)) {
        for (const s of newMembers) {
            if (eventActiveEffect === 'no_women_bookable' && s.gender === 'female') {
                data['error'] = 'no-women-allowed';
                return data;
            }
            else if (eventActiveEffect === 'no_men_bookable' && s.gender === 'male') {
                data['error'] = 'no-men-allowed';
                return data;
            }
        }
    }

    // Remove old members
    await removeTagTeamSuperstars(team);
    await addTagTeamSuperstars(team, newMembers);

    // Change team name
    let teamSuperstarsNames = commaSeparate(newMembers.sort((a, b) => a.$loki - b.$loki)
        .map(x => getSuperstarLastName(x)));
    team.name = `${faction.name} (${teamSuperstarsNames})`;

    // Remove match's feuds
    let previousMatchFeuds = await getMatchFeuds(match);
    for (const x of previousMatchFeuds) {
        await removeMatchFeud(match, x)
    }

    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(matchTeams.map(x => getRosterMemberSuperstars(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent) {
        tagTeamsPresent.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
    }
    tagTeamsPresent = getUniqueObjects(tagTeamsPresent);

    // Find existing feuds and add to match
    let matchFeuds = await getParticipantFeuds(superstarsPresent, tagTeamsPresent);
    await addMatchFeuds(match, matchFeuds);

    // Start direct feuds
    for (const feud of matchFeuds) {
        if (!feud.started && feud.directFeudEvent && !feud.ended) {
            feud.startMonth = currentGame.monthCount;
            feud.startYear = currentGame.year;
            feud.runBlowoff = false;
        }
    }

    // Reset attires
    for (const s of newMembers) {
        if (s.currentAttire > 0) {
            s.currentAttire = 0
        }
    }

    // Add managers
    if (globalUser.paid) {
        let matchManagersUsed = match.managersUsed;

        setManagersForMatchOrSegment(match, newMembers, rosterSuperstars, latestEvent);

        // Add previously added managers
        updateMatchManagersForMembersChange(match, matchManagersUsed, newMembers, oldMembers, superstarsPresent);
    }

    db.saveDatabase();

    // Get data to return
    data['match'] = await getMatchData({match, companyChampionships, rosterSuperstars});
    data['alignmentBoost'] = await getAlignmentBoost(matchTeams, userCompany.style);

    // Get unbooked and booker superstars
    const bookedSuperstars = await getSuperstarsBookedAtEventMatches(latestEvent);
    data['unbookedMatchSuperstarsUids'] = oldMembers.filter(x => !objectInArray(x, bookedSuperstars)).map(x => x.$loki);
    data['bookedMatchSuperstarsUids'] = newMembers.map(x => x.$loki);

    return data;
}

async function addFeudsToMatch(match, participants) {
    const currentGame = await getCurrentGame();

    // Get all superstars and teams present
    let superstarsPresent = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
    let tagTeamsPresent = [];
    for (const s of superstarsPresent) {
        tagTeamsPresent.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
    }
    tagTeamsPresent = getUniqueObjects(tagTeamsPresent);

    // Find existing feuds and add to match
    let matchFeuds = await getParticipantFeuds(superstarsPresent, tagTeamsPresent);
    await addMatchFeuds(match, matchFeuds);

    // Start direct feuds
    for (const feud of matchFeuds) {
        if (!feud.started && feud.directFeudEvent && !feud.ended) {
            feud.startMonth = currentGame.monthCount;
            feud.startYear = currentGame.year;
            feud.runBlowoff = false;
        }
    }

    return matchFeuds;
}

async function getHypeForMatch(participants, feuds, championships, style, annualTournament = null,
                               tournamentRound = null) {  // get_hype_for_match
    let feudHype = getHypeForFeuds(feuds, participants);
    let championshipHype = getHypeForChampionships(championships);
    let participantsHype = await getHypeForParticipants(participants);
    let alignmentHype = await getAlignmentBoost(participants, style);
    let annualTournamentHype = getHypeForAnnualTournament(annualTournament, tournamentRound);
    return Math.floor(feudHype + championshipHype + participantsHype + alignmentHype + annualTournamentHype);
}

function getHypeForChampionships(championships) {  // get_hype_for_championship_match
    let championshipHypes = {'S': 40, 'A': 30, 'B': 20, 'C': 10};
    let hype = 0;
    for (const c of championships) {
        if (c) {
            hype += championshipHypes[c.prestige] || 10
        }
    }
    if (hype > 80) {
        hype = 80
    }
    return hype;
}

function getHypeForAnnualTournament(annualTournament, tournamentRound) {  // get_annual_tournament_hype
    // Add hype for annual tournament based on round
    let annualTournamentHypes = {1: 15, 2: 30, 3: 50, 4: 75};
    let hype = 0;
    if (annualTournament) {
        hype += annualTournamentHypes[tournamentRound] || 10
    }
    return hype;
}

async function getMatchParticipantsGraphics(match, participants, participantChampionships, matchSuperstars,
                                            rosterSuperstars = null, refereeSuperstar = null, gimmick = null,
                                            championshipsToRemove = []) {  // get_match_participants_graphics
    let graphics = [];
    let addWeaponGraphic = checkToAddWeaponGraphicToSuperstar(gimmick);

    for (const participant of participants) {
        for (const superstar of (await getRosterMemberSuperstars(participant))) {
            let superstarGraphic = getGraphicForSuperstar(superstar, true);

            // Add title graphic if superstar is champion and championship has graphic
            let superstarChampionship = participantChampionships.find(x => x.superstarId === superstar.$loki && x.graphic);
            if (superstarChampionship) {
                // Don't add match championship graphics if ladder etc match
                if (!objectInArray(superstarChampionship, championshipsToRemove)) {
                    superstarGraphic['title'] = JSON.parse(JSON.stringify(superstarChampionship.graphic));
                }
            }

            // Check to add weapon graphic
            superstarGraphic['addWeaponGraphic'] = addWeaponGraphic;

            graphics.push(superstarGraphic);

            // Add manager graphic
            if (matchSuperstars.length < 7) {
                let superstarManager = await getSuperstarManagerUsedForMatchOrSegment(superstar, match.managersUsed,
                    rosterSuperstars);
                // Don't add if manager is referee
                if (superstarManager && (!refereeSuperstar || superstarManager.$loki !== refereeSuperstar.$loki)) {
                    const superstarManagerGraphic = getSuperstarManagerGraphic(superstarManager, superstar);
                    graphics.push(superstarManagerGraphic);
                }
            }
        }
    }

    // Add referee graphic
    if (refereeSuperstar && !objectInArray(refereeSuperstar, matchSuperstars)) {
        let refereeGraphic = getMatchRefereeGraphic(refereeSuperstar);
        graphics.push(refereeGraphic);
    }

    return graphics;
}

function checkToAddWeaponGraphicToSuperstar(gimmickMatch) {  // check_to_add_weapon_graphic_to_superstar
    if (gimmickMatch) {
        return gimmickMatch.addRandomWeapons;
    }
    return false;
}

function getGimmickMatchGraphic(gimmickMatch) {  // get_gimmick_match_graphic
    if (gimmickMatch) {
        return gimmickMatch.graphicType;
    }
    return null;
}

function checkHangChampionships(gimmickMatchGraphic) {  // check_hang_championships
    return !!(gimmickMatchGraphic && ['ladder', 'ladder_black', 'ladder_grey', 'ladder_orange',
        'tables_ladders_chairs'].includes(gimmickMatchGraphic));
}

function getMatchRefereeGraphic(refereeSuperstar) {  // get_match_referee_graphic
    let graphic = JSON.parse(JSON.stringify(refereeSuperstar.graphic));
    if (!graphic || Object.keys(graphic).length === 0) {
        graphic = getEmptySuperstarGraphic(refereeSuperstar)
    }
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic['isReferee'] = true;
    return graphic;
}

async function getGimmickMatchForGraphic(matchGimmick, match) {  // get_gimmick_match_for_graphic
    let gimmickMatchForGraphic = matchGimmick;

    // Get first fall gimmick match's graphic for 2/3 falls
    if (Array.isArray(match.fallGimmickNames) && match.fallGimmickNames.length > 0 && matchGimmick) {
        let matchCompany = await getGimmickMatchCompany(matchGimmick);
        if (matchCompany) {
            let companyGimmickMatches = await getCompanyGimmickMatches(matchCompany);
            let firstFallGimmickMatch = companyGimmickMatches.find(x => x.name === match.fallGimmickNames[0]);
            if (firstFallGimmickMatch) {
                gimmickMatchForGraphic = firstFallGimmickMatch
            }
        }
    }

    return gimmickMatchForGraphic;
}

async function playMatch({winnerName, uid, type, cashinData, matchFinishData, graphics} = {}) {  // play_match_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const companyRosters = await getCompanyRosters(userCompany);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const indieRoster = await getCompanyRosterByType(mainCompany, 'indie');
    const user = loadUser();

    // Get match
    const match = await Matches.get(uid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get match finish and check requirements
    if (matchFinishData) {
        let matchFinish = matchFinishesData.find(x => x.name === matchFinishData.name);
        if (matchFinish) {

            // Check if company has enough points
            if (userCompany.points < matchFinish['cost']) {
                data['error'] = 'match-finish-points';
                return data;
            }

            // Don't allow indecisive finishes in gimmick matches
            if ((await getMatchGimmickMatch(match)) && !matchFinish['changeChampionship']) {
                data['error'] = 'indecisive-finish-gimmick-match';
                return data;
            }

            // Check match finish requirements
            if (matchFinish['requirements']) {
                let check = await checkMatchFinishRequirements(matchFinish, match, winnerName, latestEvent, userCompany);
                if (check['error']) {
                    data = check;
                    return data;
                }
            }

            // Check if match finish can be re-used
            if (userCompany.specialFinishesData[matchFinish['name']]) {
                let monthsToReuse = userCompany.specialFinishesData[matchFinish['name']]['months_to_reuse'];
                if (monthsToReuse > 0) {
                    data['error'] = 'match-finish-reuse-not-available';
                    data['monthsToReuse'] = monthsToReuse;
                    return data;
                }
            }

            // Check tournament
            let matchTournament = await getMatchTournament(match);
            if (matchTournament && matchTournament.type === 'elimination') {
                // Don't allow draw finishes in elimination tournaments
                if (matchFinish['draw']) {
                    data['error'] = 'draw-elimination-tournament';
                    return data;
                }
                // Don't allow indecisive finishes in tournament finals (for awarding titles, match contracts etc)
                if (match.tournamentRound === matchTournament.rounds && !matchFinish['changeChampionship']) {
                    data['error'] = 'indecisive-finish-tournament-final';
                    return data;
                }
            }

            // Don't allow manager finishes for free users
            if (!globalUser.paid) {
                if (matchFinish['requirements'] && matchFinish['requirements'].includes('loser_has_manager')) {
                    data['error'] = 'manager-finish-paid';
                    return data;
                }
            }

            // Subtract points
            userCompany.points -= matchFinish['cost'];
        }
    }

    try {
        data = await processPlayMatch(match, winnerName, latestEvent, userCompany, mainCompany, mainRoster,
            indieRoster, currentGame, cashinData, matchFinishData, graphics);

        // Check tutorial action
        if (userCompany.storyName === 'tutorial') {
            data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['simulate_match', 'play_first_event',
                'play_second_event_main_event'])
        }

        db.saveDatabase();
    }
    catch (error) {
        data['error'] = true;
        await loadDb(db.filename);

        // Check if any empty teams present, return in error
        const match = await Matches.get(uid);
        const tagTeams = await getMatchTagTeams(match);
        for (const tagTeam of tagTeams) {
            if (!(await getTagTeamSuperstars(tagTeam)).length) {
                data['error'] = 'team-members-not-found';
                data['teamName'] = tagTeam.name;
                break;
            }
        }

        if (data['error'] !== 'team-members-not-found') {
            captureError(error);
        }
    }

    return data;
}

async function getRandomOpponent({uid, type} = {}) {  // get_random_opponent_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const companyRosters = await getCompanyRosters(userCompany);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main', companyRosters);
    const trainingRoster = await getCompanyRosterByType(userCompany, 'training', companyRosters);
    const trainingAvailableRoster = await getCompanyRosterByType(userCompany, 'trainingAvailable', companyRosters);
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    // Get match
    const match = await Matches.get(uid);
    const matchParticipants = await getMatchParticipants(match);

    // Chance to get talent from training roster
    let allTalent = [];
    let trainingTalent = false;
    if (getRandomInt(0, 100) <= 5) {
        if (type === 'singles') {
            let trainingSuperstars = (await getRosterSuperstars(trainingRoster)).concat(
                await getRosterSuperstars(trainingAvailableRoster));
            if (trainingSuperstars.length > 0) {
                allTalent = trainingSuperstars;
                trainingTalent = true;
            }
        }
        else if (type === 'tag') {
            let trainingTeams = (await getRosterTagTeams(trainingRoster)).concat(
                await getRosterTagTeams(trainingAvailableRoster))
                .filter(x => x.trio === matchParticipants[0].trio && !x.temporary);
            if (trainingTeams.length > 0) {
                allTalent = trainingTeams;
                trainingTalent = true;
            }
        }
    }

    // Otherwise get talent from main roster
    if (allTalent.length <= 0) {
        if (type === 'singles') {
            allTalent = await getRosterSuperstars(mainRoster)
        }
        else if (type === 'tag') {
            allTalent = (await getRosterTagTeams(mainRoster))
                .filter(x => x.trio === matchParticipants[0].trio && !x.temporary)
        }
    }

    // Select random opponent
    let randomOpponentData = await selectRandomOpponent(matchParticipants[0], allTalent, latestEvent);
    let opponent = randomOpponentData[0];
    let available = randomOpponentData[1];

    // Check if opponent found
    if (!opponent) {
        data['error'] = 'no-opponents-found';
        return data;
    }

    // Callup training talent if selected
    if (trainingTalent) {
        await callupTalentToMainRoster(opponent, mainRoster, userCompany, currentGame);
    }

    // Add opponent to match
    await addMatchParticipants(match, [opponent]);
    matchParticipants.push(opponent);

    // Add managers
    const participantSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();
    if (globalUser.paid) {
        setManagersForMatchOrSegment(match, participantSuperstars, rosterSuperstars, latestEvent)
    }

    db.saveDatabase();

    // Get data to return
    if (type === 'singles') {
        data['opponent'] = await getSuperstarDisplayData({
            superstar: opponent, rosterSuperstars: rosterSuperstars, managersUsed: match.managersUsed, game: currentGame
        });
    } else {
        data['opponent'] = await getTagTeamDisplayData({
            tagTeam: opponent, rosterSuperstars: rosterSuperstars, managersUsed: match.managersUsed, game: currentGame
        });
    }
    data['available'] = available.map(x => x.name);

    // Get match graphics again
    let participantChampionships = [];
    for (const matchSuperstar of participantSuperstars) {
        participantChampionships = [...participantChampionships, ...await getSuperstarChampionships(matchSuperstar)];
    }
    const refereeSuperstar = await getMatchRefereeSuperstar(match, rosterSuperstars);
    data['graphics'] = await getMatchParticipantsGraphics(match, matchParticipants, participantChampionships,
        participantSuperstars, rosterSuperstars, refereeSuperstar);

    return data;
}

async function selectRandomOpponent(participant, allTalent, event) {  // get_random_opponent
    let weights = [];
    const eventMatches = await getEventMatches(event);
    let eventMatchesParticipants = (await Promise.all(eventMatches.map(x => getMatchParticipants(x)))).flat();
    eventMatchesParticipants = eventMatchesParticipants.filter(x => x.objectName === participant.objectName);

    // Get available
    let available = [];
    let genderFiltered = [];
    let participantSuperstars = await getRosterMemberSuperstars(participant);
    for (const talent of allTalent) {
        let talentSuperstars = await getRosterMemberSuperstars(talent);
        if (talentSuperstars.every(x => checkAvailability(x, false,
            false, false) && checkSuperstarBrandAvailability(event, x)
            && talent.$loki !== participant.$loki)) {
            if (talentSuperstars.every(x => x.gender === participantSuperstars[0].gender)) {
                genderFiltered.push(talent)
            }
            available.push(talent)
        }
    }

    // Filtered by gender / not booked
    if (genderFiltered.length > 0) {
        available = available.filter(x => objectInArray(x, genderFiltered))
    }
    let notBookedFiltered = available.filter(x => !objectInArray(x, eventMatchesParticipants));
    if (notBookedFiltered.length > 0) {
        available = notBookedFiltered
    }

    // Add weights based on popularity difference
    for (const y of available) {
        let difference = Math.abs((await getRosterMemberPopularity(participant)) - (await getRosterMemberPopularity(y)));
        if (difference < 50) {
            difference = 50
        }
        let weight = 1000 / difference;
        weights.push([y, weight]);
    }

    if (weights.length <= 0) {
        return [null, null]
    }

    let opponent = weightedChoice(weights);

    return [opponent, available]
}

async function getAvailableMatchFinishes({uid}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const latestEvent = await getCompanyLatestEvent(userCompany);

    // Get match
    const match = await Matches.get(uid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get match finishes, make copy
    let matchFinishes = JSON.parse(JSON.stringify(matchFinishesData));

    // Check for unavailable match finishes
    for (const matchFinish of matchFinishes) {
        // Don't allow indecisive finishes in gimmick matches
        if ((await getMatchGimmickMatch(match)) && !matchFinish['changeChampionship']) {
            matchFinish['unavailable'] = true
        }

        // Check match finish requirements
        if (matchFinish['requirements']) {
            let check = await checkMatchFinishRequirements(matchFinish, match, null, latestEvent, userCompany);
            if (check['error']) {
                matchFinish['unavailable'] = true
            }
        }

        // Check if match finish can be re-used
        if (userCompany.specialFinishesData[matchFinish['name']]) {
            let monthsToReuse = userCompany.specialFinishesData[matchFinish['name']]['months_to_reuse'];
            if (monthsToReuse > 0) {
                matchFinish['unavailable'] = true;
                matchFinish['monthsToReuse'] = monthsToReuse;
            }
        }

        // Check tournament
        let matchTournament = await getMatchTournament(match);
        if (matchTournament && matchTournament.type === 'elimination') {
            // Don't allow draw finishes in elimination tournaments
            if (matchFinish['draw']) {
                matchFinish['unavailable'] = true
            }
            // Don't allow indecisive finishes in tournament finals (for awarding titles, match contracts etc)
            if (match.tournamentRound === matchTournament.rounds && !matchFinish['changeChampionship']) {
                matchFinish['unavailable'] = true
            }
        }

        // Don't allow manager finishes for free users
        if (!globalUser.paid) {
            if (matchFinish['requirements'] && matchFinish['requirements'].includes('loser_has_manager')) {
                matchFinish['unavailable'] = true
            }
        }
    }

    data['matchFinishes'] = matchFinishes;

    return data;
}

async function checkMatchFinishRequirements(matchFinish, match, winnerName, event, company) {
    let data = {};
    let participants = await getMatchParticipants(match);

    let participantType;
    let singlesTag = false;
    if (participants[0].objectName === 'superstar') {
        participantType = 'singles'
    }
    else {
        participantType = 'tag';
        singlesTag = participants.some(x => x.temporary && !(x.trioTagTeam || x.factionTagTeam));
    }

    // Check if one on one match and not singles tag
    if (participants.length !== 2 || singlesTag) {
        data['error'] = 'requirement-fail';
        data['requirement'] = 'one-on-one-match';
        return data;
    }

    async function faceAndHeelCheck() {
        if (participantType === 'singles') {
            if (participants.some(x => x.alignment === 'heel') && participants.some(x => x.alignment === 'face')) {
                return true;
            }
        }
        else if (participantType === 'tag') {
            let faces = false;
            let heels = false;
            for (const p of participants) {
                let participantSuperstars = await getRosterMemberSuperstars(p);
                if (participantSuperstars.every(x => x.alignment === 'heel')) {
                    heels = true;
                }
                else if (participantSuperstars.every(x => x.alignment === 'face')) {
                    faces = true;
                }
            }
            return heels && faces;
        }
        return false;
    }

    async function faceWinnerCheck() {
        // Pre-match check
        if (!winnerName) {
            let face;
            for (const x of participants) {
                if ((await getRosterMemberAlignment(x)) === 'face') {
                    face = x;
                    break;
                }
            }
            return !!face;
        }
        else {
            let winner = participants.find(x => x.name === winnerName);
            return (await getRosterMemberAlignment(winner)) === 'face';
        }
    }

    async function heelLoserCheck() {
        // Pre-match check
        if (!winnerName) {
            let heel;
            for (const x of participants) {
                if ((await getRosterMemberAlignment(x)) === 'heel') {
                    heel = x;
                    break;
                }
            }
            return !!heel;
        }
        else {
            let loser = participants.find(x => x.name !== winnerName);
            return (await getRosterMemberAlignment(loser)) === 'heel';
        }
    }

    async function hotFeudCheck() {
        return (await getMatchFeuds(match)).some(x => x.hot);
    }

    async function titleMatchCheck() {
        return (await getMatchChampionships(match)).length > 0;
    }

    async function mainEventCheck() {
        let segmentsAndMatches = await getEventMatchesAndSegments(event);
        segmentsAndMatches.sort((a, b) => a.order - b.order);
        return match.$loki === segmentsAndMatches[0].$loki && match.objectName === segmentsAndMatches[0].objectName;
    }

    async function loserHasManagerCheck() {
        // Pre-match check
        if (!winnerName) {
            for (const x of participants) {
                let participantSuperstars = await getRosterMemberSuperstars(x);
                if (participantSuperstars[0].managerId &&
                    participantSuperstars.every(y => y.managerId === participantSuperstars[0].managerId)) {
                    return true;
                }
            }
            return false;
        }
        else {
            let loser = participants.find(x => x.name !== winnerName);
            if (loser) {
                let loserSuperstars = await getRosterMemberSuperstars(loser);
                if (loserSuperstars[0].managerId &&
                    loserSuperstars.every(y => y.managerId === loserSuperstars[0].managerId)) {
                    return true;
                }
            }
            return false;
        }
    }

    async function winnerHasNoManagerCheck() {
        // Pre-match check
        if (!winnerName) {
            for (const x of participants) {
                let participantSuperstars = await getRosterMemberSuperstars(x);
                if (participantSuperstars.every(y => !y.managerId && !y.fullTimeManager)) {
                    return true;
                }
            }
            return false;
        }
        else {
            let winner = participants.find(x => x.name === winnerName);
            if (winner) {
                let winnerSuperstars = await getRosterMemberSuperstars(winner);
                if (winnerSuperstars.every(y => !y.managerId && !y.fullTimeManager)) {
                    return true;
                }
            }
            return false;
        }
    }

    async function level2ProducerCheck() {
        let staffMembers = await getCompanyStaff(company);
        let producers = getAvailableStaffMembersByRole(staffMembers, 'producer');
        return producers.find(x => x.level >= 2);
    }

    async function level3ProducerCheck() {
        let staffMembers = await getCompanyStaff(company);
        let producers = getAvailableStaffMembersByRole(staffMembers, 'producer');
        return producers.find(x => x.level >= 3);
    }

    let checkFunctions = {
        'face_vs_heel': faceAndHeelCheck,
        'face_winner': faceWinnerCheck,
        'heel_loser': heelLoserCheck,
        'hot_feud': hotFeudCheck,
        'title_match': titleMatchCheck,
        'main_event': mainEventCheck,
        'loser_has_manager': loserHasManagerCheck,
        'winner_has_no_manager': winnerHasNoManagerCheck,
        'level_2_producer': level2ProducerCheck,
        'level_3_producer': level3ProducerCheck
    };

    // Check requirements
    for (const requirement of matchFinish['requirements']) {
        const checkFunction = checkFunctions[requirement];
        if (checkFunction && !(await checkFunction())) {
            data['error'] = 'requirement-fail';
            data['requirement'] = requirement;
            return data;
        }
    }

    return data;
}

async function getRosterMembersForInterference({uid} = {}) {  // get_roster_members_for_interference
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const latestEvent = await getCompanyLatestEvent(userCompany);
    const companyChampionships = await getCompanyChampionships(userCompany);

    // Get match
    const match = await Matches.get(uid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Get match participants and all tag teams and superstars
    let matchParticipants = await getMatchParticipants(match);
    if (match.type === 'singles') {
        for (const s of matchParticipants) {
            matchParticipants.push(...(await getSuperstarTagTeams(s)).filter(x => !x.temporary));
        }
    }
    else if (match.type === 'tag') {
        matchParticipants.push(...(await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat());
    }

    // Add superstars that are available and not in match, get match managers
    let managerIds = match.managersUsed ? Object.values(match.managersUsed) : [];
    let matchManagers = [];
    let rosterMembers = [];
    for (const x of (await getRosterSuperstars(mainRoster))) {
        let superstarChampionships = getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships);
        let brandCheck = checkSuperstarBrandAvailability(latestEvent, x, superstarChampionships);
        if (checkSuperstarSegmentAvailability(x) && brandCheck && !objectInArray(x, matchParticipants)) {
            let superstarData = {'name': x.name, 'uid': x.$loki, 'type': 'superstar'};
            if (managerIds.includes(x.$loki)) {
                matchManagers.push(superstarData)
            }
            else {
                rosterMembers.push(superstarData)
            }
        }
    }

    // Add teams
    for (const x of (await getRosterActiveTagTeams(mainRoster))) {
        let superstars = await getRosterMemberSuperstars(x);
        if (superstars.every(y => checkSuperstarSegmentAvailability(y)) &&
            superstars.every(y => checkSuperstarBrandAvailability(latestEvent, y,
                getSuperstarChampionshipsFromCompanyChampionships(y, companyChampionships))) &&
            !objectInArray(x, matchParticipants)) {
            rosterMembers.push({'name': x.name, 'uid': x.$loki, 'type': 'team'})
        }
    }

    // Add factions
    for (const x of (await getRosterActiveFactions(mainRoster))) {
        let superstars = await getFactionSuperstars(x);
        // Add if at least 1 member available and not in match
        let availableSuperstars = superstars.filter(y => checkSuperstarSegmentAvailability(y) &&
            checkSuperstarBrandAvailability(latestEvent, y,
                getSuperstarChampionshipsFromCompanyChampionships(y, companyChampionships))
            && !objectInArray(y, matchParticipants));
        if (availableSuperstars.length > 0) {
            rosterMembers.push({'name': x.name, 'uid': x.$loki, 'type': 'faction'})
        }
    }

    // Sort by name
    rosterMembers.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    // Get data to return
    data['rosterMembers'] = rosterMembers;
    data['matchManagers'] = matchManagers;

    return data;
}

async function getRandomGimmickMatch({uid} = {}) {  // get_random_gimmick_match_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get match
    const match = await Matches.get(uid);
    const matchParticipants = await getMatchParticipants(match);

    // Get available gimmick matches
    let availableGimmickMatches = (await getCompanyGimmickMatches(userCompany)).filter(x => x.available &&
        !x.cashinContractName && !x.matchContractName && x.rules === null && x.consequence !== 'random_opponent'
        && !(x.special && x.name === 'Femme Fatale'));

    // Select gimmick match
    let gimmickMatch = getRandomChoice(availableGimmickMatches);

    // Add gimmick match to match
    await addGimmickMatchMatches(gimmickMatch, [match]);

    // Add custom object or location
    if (gimmickMatch.generateObject) {
        match.objectToClaim = generateGimmickMatchObjectName(matchParticipants.map(x => x.name));
    }
    if (gimmickMatch.generateLocation) {
        match.location = generateGimmickMatchLocationName(matchParticipants.map(x => x.name));
    }

    db.saveDatabase();

    // Get data to return
    data['gimmickMatch'] = {'gimmick': gimmickMatch.name,
        'generated': {'objectToClaim': match.objectToClaim, 'location': match.location}};
    data['available'] = availableGimmickMatches.map(x => x.name);

    return data;
}

async function simulateMatchWinnerRequest({uid} = {}) {  // simulate_match_view
    let data = {};

    // Get match
    const match = await Matches.get(uid);
    if (!match) {
        data['error'] = 'match-not-found';
        return data;
    }

    // Simulate winner
    let winner;
    let tournament = await getMatchTournament(match);
    if (tournament && tournament.annualTournament) {
        winner = await simulateAnnualTournamentMatchWinner(match, tournament);
    }
    else {
        winner = await simulateMatchWinner(match);
    }

    // Get data to return
    data['winnerName'] = winner.name;

    return data;
}

async function simulateMatchWinner(match, style = 'standard') {  // simulate_match_winner
    let matchParticipants = await getMatchParticipants(match);
    let matchChampionships = await getMatchChampionships(match);
    let weights = await getWinLossPercentagesWeights(matchParticipants, matchChampionships, style);
    return weightedChoice(weights);
}

async function simulateAnnualTournamentMatchWinner(match, annualTournament) {  // simulate_annual_tournament_match_winner
    let matchParticipants = await getMatchParticipants(match);
    let weights = await getAnnualTournamentWinLossPercentagesWeights(matchParticipants, annualTournament);
    return weightedChoice(weights);
}

async function getWinLossPercentagesWeights(participants, championships, style = 'standard', checkMorale = true) {  // get_win_loss_percentages
    let championshipSuperstarIds = championships.map(x => x.superstarId);
    let weights = [];
    let remainingPercentage = 100;
    let remainingParticipants = participants.length;

    // Get temporary attributes for participants (for sorting)
    for (const x of participants) {
        x.tempPopularity = await getRosterMemberPopularity(x);
        x.tempUnhappiness = await checkUnhappiness(x);
        x.tempChampion = await checkChampion(x);
    }

    async function checkUnhappiness(p) {
        if (!checkMorale) {
            return false
        }
        let s = await getRosterMemberSuperstars(p);
        return s.some(x => x.unhappy || x.contractMonthsRemaining !== null);
    }

    async function checkChampion(p) {
        let championshipFound = false;
        for (const s of (await getRosterMemberSuperstars(p))) {
            if (championshipSuperstarIds.includes(s.$loki)) {
                championshipFound = true
            }
        }
        return championshipFound;
    }

    async function checkPartTimer(p) {
        let s = await getRosterMemberSuperstars(p);
        return s.some(x => x.partTimer);
    }

    async function getAge(p) {
        let s = await getRosterMemberSuperstars(p);
        return Math.round(s.reduce((n, {age}) => n + age, 0) / s.length);
    }

    // Sort participants
    let sortedParticipants;
    let comparisonParticipant;
    if (style !== 'bizarro') {
        sortedParticipants = [...participants].sort((a, b) => b.tempUnhappiness - a.tempUnhappiness ||
            b.tempChampion - a.tempChampion || b.tempPopularity - a.tempPopularity);
        comparisonParticipant = getArrayMinByProperty(sortedParticipants, 'tempPopularity');
    }
    else {
        sortedParticipants = [...participants].sort((a, b) => b.tempUnhappiness - a.tempUnhappiness ||
            a.tempPopularity - b.tempPopularity);
        comparisonParticipant = getArrayMaxByProperty(sortedParticipants, 'tempPopularity');
    }

    // Get weights for participants except last
    for (const x of sortedParticipants.slice(0, sortedParticipants.length - 1)) {
        let partTimer = await checkPartTimer(x);
        let age = await getAge(x);

        // Divide remaining percentage equally
        let defaultPercentage = Math.floor(remainingPercentage / remainingParticipants);

        // Get win bias percentage
        let difference = Math.abs(x.tempPopularity - comparisonParticipant.tempPopularity);
        let percentage = getWinBiasPercentage(difference, participants, age, x.tempChampion, x.tempUnhappiness,
            partTimer, style, checkMorale);

        // Max value
        if (percentage + defaultPercentage > remainingPercentage) {
            percentage = remainingPercentage
        }
        else {
            // Add bias to default percentage
            percentage += defaultPercentage
        }

        // Remove percentage, participant
        remainingPercentage -= percentage;
        remainingParticipants -= 1;
        weights.push([x, percentage]);
    }

    // Get weight for last participant
    weights.push([sortedParticipants[sortedParticipants.length - 1], remainingPercentage]);

    // Add 1% chance for 0% weight
    let zeroChanceWeights = weights.filter(x => x[1] === 0);
    for (const x of zeroChanceWeights) {
        let index = weights.findIndex(y => y[0].$loki === x[0].$loki);
        weights[index] = [x[0], 1];

        // Subtract 1% chance from a random weight except this one
        let others = weights.filter(y => y[1] > 1);
        if (others.length > 0) {
            let selected = getRandomChoice(others);
            let index = weights.findIndex(y => y[0].$loki === selected[0].$loki);
            weights[index] = [selected[0], selected[1] - 1];
        }
    }

    return weights;
}

function getWinBiasPercentage(difference, participants, age, champion, unhappy, partTimer, style, checkMorale) {  // get_win_bias_percentage
    let bias = Math.ceil((Math.pow(difference * 3, 1.09)) / 20) / participants.length;

    if (bias <= 0) {
        bias = Math.floor(14 / participants.length);
    }
    if (champion) {
        if (['standard', 'quality'].includes(style)) {
            bias *= 2
        }
        else if (style === 'long-term') {
            bias *= 4
        }
        else if (style === 'bizarro') {
            bias *= 1.5
        }
    }

    if (unhappy && checkMorale) {
        bias *= 50
    }

    if (style === 'long-term') {
        if (partTimer) {
            bias /= 2.5
        }

        // Add age bias
        let ageBiases = [[25, 1], [32, 0.8], [38, 0.5], [45, 0.3]];
        let ageBias = ageBiases.find(x => x[0] > age);
        ageBias = ageBias ? ageBias[1] : 0.3;
        bias *= ageBias;
    }
    else if (style === 'bizarro') {
        if (partTimer) {
            bias /= 0.5
        }

        // Add age bias
        let ageBiases = [[25, 0.3], [32, 0.5], [38, 1], [45, 1.5]];
        let ageBias = ageBiases.find(x => x[0] > age);
        ageBias = ageBias ? ageBias[1] : 1;
        bias *= ageBias;
    }

    return Math.floor(bias);
}

async function getAnnualTournamentWinLossPercentagesWeights(participants, annualTournament = null) {  // get_win_loss_percentages
    let weights = [];
    let remainingPercentage = 100;
    let remainingParticipants = participants.length;

    // Get temporary attributes for participants (for sorting)
    for (const x of participants) {
        x.tempPopularity = await getRosterMemberPopularity(x);
    }

    // Sort by popularity
    let sortedParticipants = [...participants].sort((a, b) => b.tempPopularity - a.tempPopularity);
    let comparisonParticipant = sortedParticipants[sortedParticipants.length - 1];

    // Get weights for participants except last
    for (const x of sortedParticipants.slice(0, sortedParticipants.length - 1)) {
        // Divide remaining percentage equally
        let defaultPercentage = Math.floor(remainingPercentage / remainingParticipants);

        // Get win bias percentage
        let difference = Math.abs(getScaledPopularity(x) - getScaledPopularity(comparisonParticipant));
        let percentage = getAnnualTournamentWinBiasPercentage(difference);

        // Add bias to default percentage
        percentage += defaultPercentage;

        // Check for bribe, add to percentage if present
        if (annualTournament) {
            let participantBribe = checkAnnualTournamentParticipantBribe(annualTournament, x.$loki);
            let opponentBribe = checkAnnualTournamentParticipantBribe(annualTournament, comparisonParticipant.$loki);
            if (participantBribe && !opponentBribe) {
                percentage += 15
            }
            else if (opponentBribe && !participantBribe) {
                percentage -= 15
            }
        }
        percentage = limitValueBetweenRange(percentage, 0, 100);

        // Remove percentage, participant
        remainingPercentage -= percentage;
        remainingParticipants -= 1;
        weights.push([x, percentage]);
    }

    // Get weight for last participant
    weights.push([comparisonParticipant, remainingPercentage]);

    // Add 2% chance for 0% weight
    let zeroChanceWeights = weights.filter(x => x[1] === 0);
    for (const x of zeroChanceWeights) {
        let index = weights.findIndex(y => y[0].$loki === x[0].$loki);
        weights[index] = [x[0], 2];
    }

    return weights;
}

function getAnnualTournamentWinBiasPercentage(difference) {  // get_annual_tournament_win_bias_percentage
    // Higher the exponent, greater the bias increase with difference
    let bias = Math.ceil(Math.pow(difference, 0.67));
    return Math.floor(bias);
}

function getScaledPopularity(superstar) {  // get_scaled_popularity
    // Small increase after 1000 pop, none after 3000
    if (superstar.tempPopularity > 1000) {
        let extra = superstar.tempPopularity - 1000;
        if (extra > 2000) {
            extra = 2000
        }
        return 1000 + (extra ** 0.6)
    }
    else {
        return superstar.tempPopularity;
    }
}

function checkAnnualTournamentParticipantBribe(annualTournament, participantId) {  // check_annual_tournament_participant_bribe
    for (const x of Object.values(annualTournament.companiesData)) {
        let participantIds = x['participantIds'] || [];
        if (participantIds.includes(participantId) && x['bribed'] === true) {
            return true
        }
    }
    return false;
}

function generateGimmickMatchText(gimmickMatch, winningSuperstar, losingSuperstar) {  // generate_gimmick_match_text
    // Note: when adding text, add two superstar placeholders, otherwise it won't format

    // For specific gimmick matches
    let texts = {
        "Ladder": [
            `${winningSuperstar.name} jumped off a 20 foot ladder onto ${losingSuperstar.name}!`,
            `${winningSuperstar.name} hit ${losingSuperstar.name} with a leg drop off the ladder!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} face first into a ladder set up in the corner!`,
            `${winningSuperstar.name} suplexed ${losingSuperstar.name} off the top of a ladder, crashing onto the mat below!`,
            `${winningSuperstar.name} suplexed ${losingSuperstar.name} head first onto a ladder!`,
            `${winningSuperstar.name} powerbombed ${losingSuperstar.name} through a ladder!`,
            `${winningSuperstar.name} threw ${losingSuperstar.name} off the ladder, sending {0} through another ladder!`
                .format(losingSuperstar.objectivePronoun),
            `${winningSuperstar.name} jumped off a ladder onto ${losingSuperstar.name}, putting {0} through another ladder!`
                .format(losingSuperstar.objectivePronoun)],
        "Cage": [`${winningSuperstar.name} hit ${losingSuperstar.name} with a hurricanrana off the top of the cage!`,
                       `${winningSuperstar.name} slammed ${losingSuperstar.name} head first into the side of the cage!`,
                       `${winningSuperstar.name} dragged ${losingSuperstar.name}'s head across the entire cage!`,
                       `${winningSuperstar.name} hit ${losingSuperstar.name} with a crossbody off the top of the cage!`,
                       `${winningSuperstar.name} hit ${losingSuperstar.name} with a frog splash off the top of the cage!`,
                       `${winningSuperstar.name} hit ${losingSuperstar.name} with a leg drop off the top of the cage!`],
        "LMS": [`${winningSuperstar.name} powerbombed ${losingSuperstar.name} off the ramp and onto the tables below!`,
                `${winningSuperstar.name} threw ${losingSuperstar.name} off the stage onto the tables below!`,
                `${winningSuperstar.name} hit ${losingSuperstar.name} with {0} finisher off the ramp onto a table below!`
                    .format(winningSuperstar.possessivePronoun),
                `${winningSuperstar.name} jumped off a ladder onto ${losingSuperstar.name}, putting {0} through a table!`
                    .format(losingSuperstar.objectivePronoun)],
        "TLC": [`${winningSuperstar.name} powerbombed ${losingSuperstar.name} through a table on the outside!`,
                `${winningSuperstar.name} tipped ${losingSuperstar.name} off the ladder, sending {0} crashing outside!`.format(losingSuperstar.objectivePronoun),
                `${winningSuperstar.name} put ${losingSuperstar.name} on the announce table and dove on {0} off a ladder!`
                    .format(losingSuperstar.objectivePronoun),
                `${winningSuperstar.name} jumped for the title after walking on three ladders like a tightrope, before ${losingSuperstar.name} pulled {0} down!`
                    .format(winningSuperstar.objectivePronoun)],
        "Quit": [`${winningSuperstar.name} put ${losingSuperstar.name} through a hundred thumbtacks!`,
                   `${winningSuperstar.name} hit ${losingSuperstar.name} with a dozen consecutive chair shots!`,
                   `${winningSuperstar.name} speared ${losingSuperstar.name} through the stage screen!`,
                   `${winningSuperstar.name} jumped onto ${losingSuperstar.name} and a pile of electrical equipment below the ramp!`],
        "Cell": [`${winningSuperstar.name} threw ${losingSuperstar.name} off the side of the cell through the announce table!`,
                       `${winningSuperstar.name} speared ${losingSuperstar.name} through the cell wall!`,
                       `${winningSuperstar.name} catapulted ${losingSuperstar.name} into the steel wall!`,
                       `${winningSuperstar.name} slammed ${losingSuperstar.name} on top of the cell!`]
    };

    // For level 3 gimmick matches
    let levelThreeTexts = {
        "Cage": [`${winningSuperstar.name} jumped off the cage and crashed on top of ${losingSuperstar.name}!`,
                       `${winningSuperstar.name} hit a moonsault off the cage onto ${losingSuperstar.name}!`],
        "LMS": [`${winningSuperstar.name} jumped off the titantron onto ${losingSuperstar.name}!`,
                `${winningSuperstar.name} threw ${losingSuperstar.name} off the titantron!`],
        "TLC": [`${winningSuperstar.name} threw ${losingSuperstar.name} off a ladder through two tables on the outside!`,
                `${winningSuperstar.name} speared ${losingSuperstar.name} while {0} was dangling off the title, 15 feet in the air!`
                    .format(losingSuperstar.pronoun)],
        "Cell": [`${winningSuperstar.name} slammed ${losingSuperstar.name} through the top of the cell, sending {0} crashing to the mat below!`
                           .format(losingSuperstar.objectivePronoun),
                       `${winningSuperstar.name} dove off the top of the cell, crashing onto ${losingSuperstar.name} on the announce table below!`]
    };

    // For gimmick matches not in the list
    let defaultTexts = [
        `${winningSuperstar.name} suplexed ${losingSuperstar.name} onto the apron, slamming {0} head hard on the edge!`
            .format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} speared ${losingSuperstar.name} through the barricade!`,
        `${winningSuperstar.name} put ${losingSuperstar.name} through the announce table with an elbow drop from the top rope!`,
        `${winningSuperstar.name} hit ${losingSuperstar.name} with {0} finisher off the top rope!`
            .format(winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} was about to hit ${losingSuperstar.name} with {0} finisher before both of them collapsed from exhaustion!`
            .format(winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with a hard headbutt that almost knocked them both out!`,
        `${winningSuperstar.name} suplexed ${losingSuperstar.name} from the apron through a table outside!`,
        `${winningSuperstar.name} reversed ${losingSuperstar.name}'s finisher, cursed at {0} and hit {1} own!`
            .format(losingSuperstar.objectivePronoun, winningSuperstar.possessivePronoun),
        `${winningSuperstar.name} slapped the taste out of ${losingSuperstar.name}'s mouth before both of them started brawling!`,
        `${winningSuperstar.name} refused to give up as {0} crawled around for two minutes in ${losingSuperstar.name}'s submission!`
            .format(winningSuperstar.pronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with a lariat that knocked {0} head off!`
            .format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} spat in ${losingSuperstar.name}'s face when {0} asked for a handshake!`
            .format(losingSuperstar.pronoun),
        `${winningSuperstar.name} got up from ${losingSuperstar.name}'s finisher before asking {0} to hit another!`
            .format(losingSuperstar.objectivePronoun),
        `${winningSuperstar.name} and ${losingSuperstar.name} started a battle of forearms before both kicked each other's heads off!`,
        `${winningSuperstar.name} kicked out of ${losingSuperstar.name}'s finisher, used {0} body to get up and asked to be finished off!`
            .format(losingSuperstar.possessivePronoun),
        `${winningSuperstar.name} hit ${losingSuperstar.name} with three consecutive finishers!`
    ];

    // Get choices
    let choices = defaultTexts;
    for (const key of Object.keys(texts)) {
        if (gimmickMatch && gimmickMatch.name.split(' ').some(y => y.toLowerCase() === key.toLowerCase())) {
            choices = texts[key];
            if (gimmickMatch.level >= 3 && Object.keys(levelThreeTexts).includes(key)) {
                choices.push(...levelThreeTexts[key])
            }
            break;
        }
    }

    return getRandomChoice(choices);
}

function updateMatchManagersForMembersChange(match, previousManagersUsed, newMembers, oldMembers, superstarsPresent) {
    let newMembersIds = newMembers.map(x => x.$loki.toString());
    let oldMembersIds = oldMembers.map(x => x.$loki.toString());
    let superstarsPresentIds = superstarsPresent.map(x => x.$loki);
    for (const [superstarId, managerId] of Object.entries(previousManagersUsed)) {
        if (!superstarsPresentIds.includes(managerId) && !Object.values(match.managersUsed).includes(managerId)) {
            if (oldMembersIds.includes(superstarId) && !newMembersIds.includes(superstarId)) {
                let replacingSuperstarId = newMembersIds.find(x => !match.managersUsed[x]);
                if (!replacingSuperstarId) {
                    replacingSuperstarId = newMembersIds.find(x => !oldMembersIds.includes(x));
                }
                match.managersUsed[replacingSuperstarId] = managerId;
            }
            else {
                match.managersUsed[superstarId] = managerId
            }
        }
    }
}

export {getMatchData, getMatchEventTitle, getMatchHistoryData, getMatchName, deleteCompanyMatch,
    addMatch, addGimmickMatchToMatch, changeMatchOrSegmentOrder, removeChampionshipFromMatch, changeMatchChampionships,
    getMatchChampionshipsForSelection, getAddMatchManagerSelections, addManagerToMatch, getRemoveMatchManagerSelections,
    removeManagerFromMatch, changeFactionTagTeamMembers, changeTrioTagTeamMembers, deleteMatch, addFeudsToMatch,
    getHypeForMatch, getMatchHype, playMatch, getRandomOpponent, getAvailableMatchFinishes, getTournamentFinalBonus,
    getRosterMembersForInterference, getRandomGimmickMatch, simulateMatchWinnerRequest, generateGimmickMatchText,
    selectRandomOpponent, getMatchRefereeSuperstar, getAlignmentBoost, getGimmickMatchForGraphic, getGimmickMatchGraphic,
    checkHangChampionships, getMatchParticipantsGraphics, simulateAnnualTournamentMatchWinner, getWinLossPercentagesWeights,
    getAnnualTournamentWinLossPercentagesWeights, simulateMatchWinner, getSuperstarsBookedAtEventMatches}